// Korean (default) — matches the original hardcoded strings verbatim.
const ko = {
  // ── StudentLogin ───────────────────────────────────────────
  'login.title': '학생 로그인',
  // Splash login flow uses these labels above each input.
  'login.classCode.label': '반 코드',
  'login.classCode.placeholder': '예: A7K-92F',
  // The school-issued login ID, the same across school years. Not 학번:
  // a K-12 학번 is 학년+반+번호 and is reassigned every March (#1594).
  'login.studentId.label': '아이디',
  'login.studentId.placeholder': '예: 24-005',
  // Issue #967 — password login path (학교 코드 + 아이디 + 비밀번호).
  'login.schoolCode.label': '학교 코드',
  'login.schoolCode.placeholder': '예: SEOUL-01',
  'login.password.label': '비밀번호',
  'login.password.placeholder': '비밀번호 입력',
  // Issue #967 — secondary affordance toggling between the password
  // form and the legacy first-login bootstrap form.
  'login.toggle.toBootstrap': '처음이신가요? 비밀번호 설정하기',
  'login.toggle.toPassword': '비밀번호가 있어요',
  'login.button': '시작하기',
  'login.loading': '로그인 중...',
  // Issue #1104 — generic, no enumeration oracle (0046 discipline): the
  // password path has no class code, so name the three fields it actually
  // uses without revealing which one was wrong.
  'login.error.invalidCredentials':
    '학교 코드, 아이디 또는 비밀번호가 올바르지 않습니다',
  // Logged-in module picker.
  'login.welcome': '{id}님, 환영합니다',
  'login.greeting': '안녕, 다시 만나서 반가워',
  'login.greetingSub': '오늘은 어디서부터 이어갈까?',
  'login.allModules': '전체 모듈',
  'login.moduleCount': '{n} 모듈',
  'login.selectModule': '학습할 단원을 선택하세요:',
  'login.startModule': '학습 시작',
  'login.startingModule': '시작 중...',
  'login.noModules':
    '아직 등록된 단원이 없습니다. 선생님에게 문의하세요.',
  'login.sessionStartError': '세션 시작 실패: ',
  'login.logout': '로그아웃',
  // Subtle indicator shown in LessonPicker while a silent
  // /auth/student-me re-fetch is in flight (#517).
  'login.refreshing': '업데이트 중…',

  // ── ADR 0051 Phase 4 — school-search picker / forgot-pw / join ──
  // Issue #1096 — chip hint when the student is in no class yet
  // (class_code is null for an admin-provisioned, unenrolled student).
  'login.noClassChip': '반 없음',
  // School-name search picker — replaces typing the raw school code.
  'login.schoolSearch.placeholder': '학교 이름 검색',
  'login.schoolSearch.loading': '검색 중...',
  'login.schoolSearch.noResults': '일치하는 학교가 없어요',
  // #1122 — shown when the search request itself fails (서버 오류·네트워크). A
  // DISTINCT message from noResults so a backend outage doesn't read as "your
  // school isn't registered"; steers the student to the manual-code fallback.
  'login.schoolSearch.searchUnavailable':
    '학교 검색을 일시적으로 사용할 수 없어요. 아래에서 학교 코드를 직접 입력해 주세요.',
  'login.schoolSearch.manualToggle': '학교 코드 직접 입력',
  'login.schoolSearch.searchToggle': '학교 이름으로 검색',
  // Forgot-password request (in-app reset queue). No oracle in the copy —
  // the confirmation is identical whether or not the id resolved.
  'forgot.link': '비밀번호를 잊으셨나요?',
  'forgot.button': '요청 보내기',
  'forgot.backToLogin': '로그인으로 돌아가기',
  'forgot.confirm':
    '비밀번호 재설정 요청을 보냈어요. 선생님(관리자)이 확인하면 도와드릴 거예요.',
  'forgot.error': '요청을 보내지 못했어요. 잠시 후 다시 시도해 주세요.',
  // Dashboard empty-state — a class-less student self-enrolls with a code.
  'join.empty.title': '아직 반에 들어가지 않았어요',
  'join.empty.body': '선생님께 받은 반 코드를 입력해서 반에 들어가세요.',
  'join.code.label': '반 코드',
  'join.code.placeholder': '예: A7K-92F',
  'join.submit': '반 들어가기',
  'join.submitting': '들어가는 중...',
  'join.error.notFound': '반 코드를 찾을 수 없어요. 선생님께 확인해 주세요.',
  'join.error.generic': '반에 들어가지 못했어요. 다시 시도해 주세요.',

  // ── LessonPicker (ADR 0040 chunk 6) ────────────────────────
  // 학생용 단원 선택 화면 — chunk 6의 진행 상태 칩 + "이어서 학습하기"
  // CTA. 상태 카피는 ``services.student_progress``가 반환하는 네 가지
  // 백엔드 상태와 1:1 대응.
  'lessonPicker.continueLabel': '이어서 학습하기',
  'lessonPicker.lessonLabel': '{n}차시',
  'lessonPicker.status.notStarted': '시작 전',
  'lessonPicker.status.inProgress': '학습 중',
  'lessonPicker.status.mastered': '완료',
  'lessonPicker.status.abandoned': '다시 시작',

  // ── SessionLessonRail (#1331) ──────────────────────────────
  // 세션 화면 왼쪽의 레슨 목록. 상태 단어는 lessonPicker.status.* 재사용.
  'lessonRail.label': '이 수업의 레슨',
  'lessonRail.loading': '레슨 목록을 불러오는 중...',
  'lessonRail.error': '레슨 목록을 불러오지 못했어요.',
  'lessonRail.upNext': '다음 레슨',
  'lessonRail.current': '지금 학습 중',
  'lessonRail.blocked': '답변을 처리하고 있어요. 끝나면 다시 눌러 주세요.',
  'lessonRail.startError': '레슨을 시작하지 못했어요. 다시 시도해 주세요.',
  'lessonRail.switchConfirm.title': '다른 레슨으로 이동할까요?',
  'lessonRail.switchConfirm.body':
    '“{name}” 레슨을 새로 시작해요. 지금 하던 레슨은 마치지 않은 상태로 남아요.',
  'lessonRail.switchConfirm.confirm': '이동하기',

  // ── SessionConceptRail (#1332) ─────────────────────────────
  // The lesson's concepts beside the session. The review marker reuses
  // the notes' wording (notes.focusSectionBadge / focusTocMarker).
  'conceptRail.label': '이 레슨의 개념',
  'conceptRail.loading': '개념을 불러오는 중...',
  'conceptRail.error': '개념 목록을 불러오지 못했어요.',
  'conceptRail.focusMarker': '복습 필요',
  'conceptRail.focusLegend': '복습이 필요한 개념',

  // ── TeacherDashboard ───────────────────────────────────────
  'teacher.title': '교사 대시보드',
  'teacher.noOrg.title': '초대 대기 중',
  'teacher.noOrg.hint':
    '관리자(IT 담당자)로부터 학교에 초대받아야 합니다. 관리자에게 이 이메일 주소로 초대를 보내달라고 요청하세요. 초대를 수락하면 이 페이지가 자동으로 업데이트됩니다.',

  // ── ClassListPage (ADR 0040 chunk 5) ───────────────────────
  // Multi-class landing. 0 classes → empty state with inline
  // ClassCodeBar; 1 class → auto-redirect to its dashboard;
  // N classes → card grid sorted by recent activity.
  'classList.title': '내 수업',
  'classList.subtitle': '{school} 학교의 수업을 관리하세요.',
  'classList.subtitleNoOrg': '관리할 수업을 선택하세요.',
  'classList.resume': '{code} 계속하기',
  'classList.loading': '수업 목록을 불러오는 중...',
  'classList.error.title': '수업 목록을 불러올 수 없습니다',
  'classList.error.body':
    '일시적인 오류일 수 있습니다. 페이지를 새로고침해 주세요.',
  'classList.empty.title': '아직 등록된 수업이 없습니다',
  'classList.empty.body':
    '첫 수업을 만들어 학생들과 코드를 공유해 보세요.',
  'classList.card.modules': '단원',
  'classList.card.students': '학생',
  'classList.card.noModules': '단원 없음',
  'classList.card.created': '개설 {date}',
  // Phase 3 (#777) redesign keys.
  'classList.eyebrow': '{school}',
  'classList.eyebrowNoOrg': '내 학교',
  'classList.meta': '수업 {classes}개, 학생 {students}명',
  'classList.section.all': '전체 수업',
  'classList.section.recent': '최근 활동순',
  'classList.col.class': '수업',
  'classList.col.subject': '과목',
  'classList.col.latest': '최근 단원',
  'classList.col.status': '상태',
  'classList.empty.create.title': '첫 수업을 만드세요',
  'classList.empty.create.body':
    '수업은 학생들에게 공유할 참여 코드를 제공하고, 모든 단원·평가·튜터링 세션이 모이는 공간이 됩니다. 차시·과목·학기별로 자유롭게 만들 수 있습니다.',
  'classList.empty.create.cta': '새 반',
  'classList.resumeCard.eyebrow': '이어서 시작하기',
  'classList.resumeCard.sub': '{subject} · 마지막 열람 {date}',
  'classList.resumeCard.subNoSubject': '마지막 열람 {date}',
  'classList.resumeCard.statStudents': '학생',
  'classList.resumeCard.statModules': '단원',
  'classList.resumeCard.statMastery': '숙련도',
  'classList.resumeCard.code': '반 코드',
  'classList.resumeCard.open': '수업 열기',
  // Subject labels.
  'subject.math': '수학',
  'subject.science': '과학',
  'subject.english': '영어',
  'subject.history': '역사',
  'subject.misc': '기타',
  'teacher.students.section': '등록된 학생',
  'teacher.students.addPlaceholder': '학생 ID 입력',
  'teacher.students.addButton': '학생 추가',
  'teacher.students.delete': '삭제',
  'teacher.students.deleteConfirm': '이 학생을 삭제하시겠습니까?',
  'teacher.students.empty': '아직 등록된 학생이 없습니다.',

  // ── ClassCodeBar ───────────────────────────────────────────
  'classCode.label': '수업 코드:',
  'classCode.placeholder': '생성 버튼을 눌러주세요',
  'classCode.generate': '수업 코드 생성',
  'classCode.generating': '생성 중...',
  'classCode.generateError': '수업 생성 실패: ',
  'classCode.shareHint': '이 코드를 학생들에게 공유하세요:',
  'classCode.copy': '복사',
  'classCode.copied': '복사됨!',

  // ── ModuleTable ────────────────────────────────────────────
  'modules.title': '단원 관리',
  'modules.col.name': '단원명',
  'modules.col.subject': '과목',
  'modules.col.pdf': 'PDF 업로드',
  'modules.col.note': '교사 메모',
  'modules.col.status': '상태',
  'modules.col.actions': '관리',
  'modules.col.order': '순서',
  'modules.addButton': '단원 추가',

  // ── ModuleRow ──────────────────────────────────────────────
  'module.namePlaceholder': '단원명',
  'module.notePlaceholder': '교사 메모...',
  'module.pdfNone': 'PDF 없음',
  'module.deleteConfirm': '이 단원을 삭제하시겠습니까?',
  'module.save': '저장',
  'module.saving': '저장 중...',
  'module.delete': '삭제',
  'module.nameRequired': '단원명을 입력해주세요',
  'module.saveFailed': '저장 실패',
  'module.deleteFailed': '삭제 실패',
  'module.saveError': '단원 저장 오류: ',
  'module.errorPrefix': '오류: ',
  'module.status.pending': '준비 중',
  'module.status.extracting': '텍스트 추출 중...',
  'module.status.building': '생성 중',
  'module.status.ready': '준비 완료',
  'module.status.failed': '생성 실패',
  'module.subject.misc': '기타',
  'module.subject.math': '수학',
  'module.subject.science': '과학',
  'module.subject.english': '영어',
  'module.subject.history': '역사',
  // ADR 0040 chunk 5 — reorder affordance on each module row.
  // Up/down arrows interpolate the module name so screen readers
  // announce "Move 다항식과 인수분해 up" instead of just "Move up".
  'module.reorder.up': '{name} 위로 이동',
  'module.reorder.down': '{name} 아래로 이동',
  'module.reorderError': '단원 순서 변경 오류: ',
  'module.reorderFailed': '순서 변경 실패',

  // ── StudentAssessments ─────────────────────────────────────
  'assessments.title': '학생 평가 결과',
  'assessments.empty':
    '아직 평가 결과가 없습니다. 학생이 튜터링 세션을 완료하면 여기에 표시됩니다.',
  'assessments.strengths': '강점',
  'assessments.weaknesses': '약점',
  'assessments.learningStyle': '학습 유형',

  // ── ChatMessage ────────────────────────────────────────────
  'chat.role.tutor': '튜터',
  'chat.role.self': '나',

  // ── TutoringSession ────────────────────────────────────────
  'session.loading': '세션 불러오는 중...',
  // #623 — 세션 로드 실패 복구 패널. 기존에는 catch에서 alert만
  // 띄우고 ``session``이 null로 남아 "세션 불러오는 중..." 화면이
  // 무한히 표시되었습니다. 재시도 버튼과 학습 화면으로 돌아가는
  // CTA를 제공합니다.
  'session.loadError.notFound.title': '이 세션을 찾을 수 없어요',
  'session.loadError.notFound.body':
    '이 세션은 더 이상 사용할 수 없거나 본인의 세션이 아닙니다. 링크가 오래되었을 수 있어요 — 학습 화면으로 돌아가서 새 세션을 시작해 주세요.',
  'session.loadError.generic.title': '세션을 불러올 수 없어요',
  'session.loadError.generic.body':
    '세션을 불러오는 중에 문제가 발생했어요. 연결 상태를 확인하고 다시 시도해 보세요 — 계속 실패하면 학습 화면으로 돌아가 주세요.',
  'session.loadError.retry': '다시 시도',
  'session.loadError.back': '학습 화면으로',
  // Phase-transition intermediates (issue #142). Shown briefly while
  // the LLM round-trip lands; the visible chrome (session-bar +
  // gradient backdrop) persists across phases so only the inner panel
  // fades.
  'session.preparingTutor': 'AI 튜터를 준비하고 있어요',
  'session.wrappingUp': '세션을 마무리하고 있어요',
  // Inline success feedback shown next to the assessment submit button
  // immediately on phase-advance, before the assessment view fades out.
  'session.assessmentSubmitted': '제출 완료',
  'session.lastAssessmentSubmitted': '마지막 문제 제출 완료!',
  'session.assessment.title': '수준 평가',
  'session.assessment.intro': '다음 문제를 풀어 현재 이해도를 확인합니다.',
  // #204 — aria-labels for the per-answer feedback banner's icon. The
  // visible content is the backend-generated feedback string itself;
  // these only feed screen readers via aria-label on the icon span.
  'session.assessment.feedbackCorrect': '정답',
  'session.assessment.feedbackIncorrect': '오답',
  // #847 — the eval-failed TRANSIENT banner. ``evaluate_answer`` failed
  // (provider error / parse / schema reject), so the verdict is UNKNOWN
  // and the same question is re-asked. The amber ⚠ banner renders the
  // backend's transient message; this key is its icon aria-label.
  'session.assessment.feedbackEvalFailed': '평가 실패',
  // Escalated hint appended after N (≥3) consecutive eval failures so a
  // systematic outage doesn't read as an infinite "try again" loop.
  'session.assessment.feedbackEvalFailedPersistent':
    '계속 문제가 발생하고 있습니다. 잠시 후 다시 시도해 주세요.',
  // #848 — system-wide assessment-grading incident banner (vs the
  // per-student transient banner above). Shown at the top of the session
  // when the platform is seeing an elevated number of grading failures
  // across students (e.g. a provider outage). Warm + reassuring, no
  // numbers, no internal jargon — "we see it and we're on it" so the
  // student feels prioritized, not "this paid software is broken".
  'session.incident.title': '채점이 잠시 불안정해요',
  'session.incident.body':
    '지금 답변 채점에 일시적인 문제가 있어 저희가 바로 해결하고 있어요. 계속 학습하셔도 되며, 채점은 잠시 후 정상으로 돌아옵니다.',
  // Session-bar crumbs: "모듈 / <name>"
  'session.bar.crumbsRoot': '모듈',
  'session.tutorName': 'eehae 튜터',
  'session.tutorSub': '튜터링',
  'session.live': '실시간',
  'session.answerPlaceholder': '답변을 입력하세요...',
  'session.loadingQuestions': '문제 불러오는 중...',
  'session.submit': '답변 제출',
  'session.submitting': '제출 중...',
  'session.tutoring.title': '튜터링 세션',
  'session.end': '세션 종료',
  'session.endConfirm': '세션을 종료하시겠습니까?',
  'session.send': '보내기',
  // Direction A (ADR 0073) — worksheet copy for the assessment + transcript labels.
  'session.assessment.openHint': '2~3문장이면 충분해요. 틀려도 괜찮아요. 답에 따라 다음 설명이 달라질 뿐이에요.',
  'session.assessment.submitHint': '제출하면 바로 저장돼요.',
  'session.tutorLabel': '튜터',
  'session.me': '나',
  'session.sending': '전송 중...',

  // AI Basic Act generative-AI transparency (#1327 §1b). The chip is
  // the standing in-session notice; the mark labels generated output.
  // Korean copy pending native review.
  'session.aiNotice': '생성형 AI 사용',
  'session.aiNoticeDetail': '이 수업의 문제와 설명은 생성형 AI가 만들어요.',
  'session.aiGenerated': 'AI 생성',

  // ADR 0030 Phase 6 — 정리노트 (notes-prose)
  'session.openNotes': '정리노트 열기',
  'notes.tutorTab': '튜터',
  'notes.notesTab': '정리노트',
  'notes.versionLabel': '버전',
  'notes.backToTutor': '튜터로 돌아가기',
  'notes.tocLabel': '목차',
  'notes.tldrLabel': '한눈에',
  'notes.collapse': '접기',
  'notes.expand': '펼치기',
  'notes.sourceLabel': '출처',
  'notes.sourceDescription': '원본 PDF 자료',
  'notes.moduleCrumb': '내 학습 / 모듈',
  'notes.askAbout': '이 부분 묻기',
  'notes.askPrompt': '읽다가 막히면 여기서 바로 물어봐.',
  'notes.askPlaceholder': '예) 엽록소가 왜 초록색인지 다시 설명해줘',
  'notes.askSend': '튜터에게 보내기',
  'notes.askDisabledHint': '이 기능은 다음 업데이트에서 활성화됩니다',
  'notes.askFootnote': '튜터가 이 정리노트를 같이 보고 있어요. 질문하면 정리노트의 §번호로 짚어줍니다.',
  'notes.loadError': '정리노트를 불러올 수 없습니다.',
  'notes.notReadyTitle': '정리노트가 아직 준비되지 않았어요',
  'notes.notReadyBody': '이 모듈의 정리노트는 모듈 빌드가 완료된 후 생성됩니다.',
  'notes.backToSession': '세션으로 돌아가기',
  'notes.citationFallback': '출처',
  // Per-student note re-prioritization (#1207 / #1176 §3c). Surfaced
  // only when the student has weak concepts the note covers.
  'notes.focusBadge': '나를 위한 추천',
  'notes.focusIntro':
    '아직 충분히 익히지 못한 개념을 다루는 부분이에요. 복습에 집중할 수 있도록 강조해 두었어요.',
  'notes.focusSectionBadge': '복습 필요',
  'notes.focusTocMarker': '복습이 필요한 개념',
  // Tutoring input placeholder updated to match design copy.
  'session.inputPlaceholder': '메시지를 입력하세요. Shift+Enter로 줄바꿈',
  // Quick-action buttons under the tutoring input (ADR 0055). The
  // label doubles as the student's transcript bubble for the press.
  'session.action.explain': '잘 모르겠어요, 설명해 주세요',
  'session.action.skip': '이 질문 스킵하기',
  'session.action.report': '문제가 이상해요',
  'session.action.reportConfirm':
    '이 문제를 신고할까요? 이 개념은 학습 목록에서 제외되고, 선생님이 문제를 확인하게 됩니다.',
  'session.errorPrefix': '오류: ',
  // Streaming-failover (#280). The primary LLM provider failed mid-
  // stream, the backend is re-running against the next provider in
  // the chain. Brief beat shown above the (just-cleared) assistant
  // bubble so the student perceives "the AI took a moment to
  // reconsider" rather than a hiccup. Cleared as soon as the first
  // delta from the fallback lands.
  'session.reconsidering': '다시 생각 중…',
  // SSE chunk-timeout recovery (#163 item 3). The tutoring stream went
  // silent past the 15s chunk-timeout — no token AND no backend
  // heartbeat — so the connection is treated as lost. `connectionRetrying`
  // shows during the automatic single retry; `connectionLost` +
  // `retry` surface once that retry has also gone silent and the student
  // gets a manual Retry. Replaces the prior infinite "Waiting for
  // tutor…" hang with an explicit, recoverable state.
  'session.connectionRetrying': '연결이 끊겼습니다 — 다시 연결 중…',
  'session.connectionLost': '연결이 끊겼습니다. 메시지가 전송되지 않았습니다.',
  'session.retry': '다시 시도',
  // 409 conflict — another concurrent action (different tab, network
  // retry) bumped the session's version while this submit was in flight.
  // Backend's #106 optimistic-locking surfaces this instead of silently
  // clobbering the other writer's state.
  'session.staleConflict':
    '이 세션이 다른 곳에서 업데이트되었습니다. 페이지를 새로고침해서 최신 상태를 가져올까요?',
  // Session JSON-column corruption (#108). Engine state failed to
  // deserialize — probably a backend crash mid-write or a schema
  // migration mismatch. Backend marks the session ``corrupted`` and
  // returns it; we render this panel as the explicit dead-end so the
  // student knows to start a new session instead of seeing a generic
  // 500. Old messages remain in the DB for forensics.
  'session.corrupted.title': '이 세션을 이어갈 수 없어요',
  'session.corrupted.body':
    '세션 데이터에 문제가 발생해서 이 세션은 더 이상 진행할 수 없습니다. 같은 단원으로 새 세션을 시작해 주세요. 이미 작성한 답변은 안전하게 저장되어 있어요.',
  'session.corrupted.cta': '새 세션 시작하기',
  'session.complete.title': '오늘의 학습 정리',
  'session.complete.headline': '오늘은 한 칸 더 나아갔어요',
  'session.complete.sub': '잘했어요. 아래는 오늘 세션을 바탕으로 한 짧은 진단이에요.',
  'session.complete.resultTitle': '학습 평가 결과',
  'session.complete.strengths': '잘한 점',
  'session.complete.report': '세션 리포트:',
  'session.complete.weaknesses': '더 봐야 할 점',
  'session.complete.concepts': '오늘 다룬 개념',
  'session.complete.map': '개념 지도',
  'session.complete.map.intro': '이번 단원의 개념이 어떻게 이어지는지 보여 줘요.',
  'session.complete.map.arrows':
    '화살표는 먼저 알아야 할 개념에서 다음 개념으로 향해요.',
  'session.complete.map.legend': '범례',
  'session.complete.map.status.mastered': '숙달',
  'session.complete.map.status.inferred': '숙달 추정',
  'session.complete.map.status.inProgress': '학습 중',
  'session.complete.map.status.notAssessed': '아직 평가 전',
  'session.complete.map.inferredNote':
    '숙달 추정: 직접 답하지는 않았지만, 관련 개념에 대한 답이나 이전 학습을 보고 알고 있다고 판단한 개념이에요.',
  'session.complete.map.buildsOn': '먼저 알아야 할 개념: {names}',
  'session.complete.map.aria':
    '개념 지도, 개념 {n}개. 방향키로 개념 사이를 이동할 수 있어요.',
  'session.complete.learningStyle': '학습 유형:',
  'session.complete.summaryTitle': '오늘의 정리',
  'session.complete.mastery': '숙달도:',
  'session.complete.mastery.full': '완전 숙달',
  'session.complete.mastery.partial': '부분 숙달',
  'session.complete.mastery.insufficient': '추가 학습 필요',
  'session.complete.fallback': '세션이 종료되었습니다.',
  'session.back': '모듈로 돌아가기',

  // ── Language switcher ──────────────────────────────────────
  'lang.toggleLabel': 'EN',

  // ── Splash screen ──────────────────────────────────────────
  'splash.subtitle': '스스로 이해하다',
  'splash.loginSubtitle':
    '학교 코드, 학교에서 받은 아이디, 비밀번호를 입력하면 오늘의 튜터링이 시작돼요.',
  // Issue #967 — shown above the legacy first-login bootstrap sub-form.
  'splash.loginSubtitleBootstrap':
    '아직 비밀번호가 없다면, 반 코드와 학교에서 받은 아이디로 처음 로그인할 수 있어요.',
  // ADR 0051 Phase 4 — shown above the forgot-password request sub-form.
  'splash.loginSubtitleForgot':
    '학교와 아이디를 입력하면 선생님(관리자)께 비밀번호 재설정을 요청해요.',
  'splash.teacher': '선생님 대시보드',
  // Issue #1104 — the student CTA opens the school + student-ID + password
  // sign-in (a class code is for joining a class after login, not for
  // signing in), so the button reads as a student login, not the old
  // class-code prompt "수업 코드 입력".
  'splash.student': '학생 로그인',
  'splash.back': '돌아가기',
  'splash.admin': '관리자',
  'splash.signedOut': '로그아웃되었습니다',
  // #832 — shown on the home splash when a signed-in non-admin user
  // tries to access an admin route and is redirected here.
  'splash.notAuthorized': '이 계정으로는 관리자 페이지에 접근할 수 없습니다.',
  // Scroll-down affordance shown on the splash when the marketing
  // extension is mounted below it. Hidden in login mode (the form is
  // already drawing focus down).
  'splash.scrollHint': '아래로 스크롤',

  // ── Theme switcher ─────────────────────────────────────────
  'theme.light': '기본',
  'theme.dark': '다크',
  'theme.colorful': '컬러풀',

  // ── Brand ──────────────────────────────────────────────────
  'brand.name': 'eehae',

  // ── Auth split-screen marketing panel ─────────────────────
  'auth.left.eyebrow.teacher': '교사용',
  'auth.left.eyebrow.admin': '학교 관리자용',
  'auth.left.headline.teacher.signin': '수업으로 다시 오신 걸 환영합니다.',
  'auth.left.headline.teacher.signup': '생각하는 기계에게 가르치는 법을 알려주세요.',
  'auth.left.headline.admin.signin': '학교 운영, 차분하게.',
  'auth.left.headline.admin.signup': '학교를 eehae로 옮겨오세요.',
  'auth.left.subhead.teacher':
    'eehae가 평가, 연습, 그리고 인내심을 맡습니다. 선생님은 수업 시간을 다시 가져갑니다.',
  'auth.left.subhead.admin':
    '교사 좌석, 결제, 학교의 학습 흐름 — 하나의 콘솔에서 관리하세요.',
  'auth.left.foot.privacy': '개인정보처리방침',
  'auth.right.crosslink.signin.teacher.prompt': 'eehae가 처음이신가요?',
  'auth.right.crosslink.signin.teacher.cta': '계정 만들기',
  'auth.right.crosslink.signin.admin.prompt': '학교를 설정하지 않으신가요?',
  'auth.right.crosslink.signin.admin.cta': '교사 로그인',
  'auth.right.crosslink.signup.prompt': '이미 계정이 있으신가요?',
  'auth.right.crosslink.signup.cta': '로그인',

  // ── Showcase design system: dashboard chrome (#117/#118) ───
  'nav.section.teaching': '수업',
  'nav.section.classes': '반',
  'nav.section.school': '학교',
  'nav.overview': '대시보드',
  'nav.students': '학생',
  'nav.modules': '모듈',
  'nav.assessments': '평가',
  'topbar.search': '학생, 모듈, 반 검색',
  'topbar.invite': '초대',
  'topbar.newClass': '새 반',
  'topbar.newClass.creating': '생성 중…',
  'topbar.newClass.error': '반 생성 실패: ',
  'topbar.comingSoon': '준비 중',
  // ── TeacherTopbar search dropdown (#608) ───────────────────
  'search.group.students': '학생',
  'search.group.modules': '모듈',
  'search.group.classes': '반',
  'search.noResults': '결과 없음',
  'search.loading': '검색 중…',
  'classNameDialog.create.title': '새 반',
  'classNameDialog.rename.title': '반 이름 변경',
  'classNameDialog.label': '반 이름',
  'classNameDialog.placeholder': '예: 3교시 수학',
  'classNameDialog.hint': '최대 100자. 비워두면 반 코드만 표시됩니다.',
  'classNameDialog.create.submit': '반 만들기',
  'classNameDialog.create.submitting': '생성 중…',
  'classNameDialog.rename.submit': '저장',
  'classNameDialog.rename.submitting': '저장 중…',
  'classNameDialog.cancel': '취소',
  'classNameDialog.error': '저장 실패: ',
  // ── Build-truncation notice dialog (#1225 / #1176 §1b) ──────
  'buildNotice.title': '단원 자료가 일부만 사용되었습니다',
  'buildNotice.intro': '업로드한 자료가 한 단원에 담기에 너무 길어, 빌드 시 앞부분만 사용되었습니다. 영향을 받은 단원:',
  'buildNotice.coverage': '약 {used}자 / 전체 {source}자 사용 (약 {dropped}자 누락)',
  'buildNotice.renamed': '이름이 “{original}” → “{applied}”(으)로 변경되었습니다.',
  'buildNotice.recommend': '권장 조치: 나머지 내용을 챕터별로 다시 업로드(챕터 빌드)하거나, 현재의 일부 빌드를 그대로 사용하세요.',
  'buildNotice.action.accept': '일부 빌드 사용',
  'buildNotice.action.keepName': '원래 이름 유지',
  'buildNotice.action.rebuild': '챕터로 다시 빌드',
  'buildNotice.acknowledging': '저장 중…',
  'buildNotice.error': '저장하지 못했습니다. 다시 시도하세요.',
  'buildNotice.dismiss': '닫기',
  'hero.renameClass': '이름 변경',
  'classList.card.rename': '이름 변경',
  'classList.card.menuLabel': '반 작업',
  'hero.eyebrow': '오늘의 반',
  'hero.classCodeLabel': '반 코드',
  'hero.classCodeCopy': '복사',
  // Issue #967 — school login code pill (password-login: 학교 코드 + 아이디 + 비밀번호).
  'hero.schoolCodeLabel': '학교 코드',
  'hero.schoolCodeCopy': '복사',
  'hero.schoolCodeHint': '학생은 이 코드와 학생 ID, 비밀번호로 로그인합니다.',
  'hero.pulse.active': '이번 주 학습 학생',
  'hero.pulse.activeHint': '7일 전 대비',
  'hero.pulse.sessions': '이번 주 세션',
  'hero.pulse.sessionsHint': '일별 세션 수',
  'hero.pulse.mastery': '반 평균 숙련도',
  'hero.pulse.attention': '주목 필요',
  'hero.pulse.attentionHint': '명',
  // 맴돌이 학습 (wheel-spinning, #1376) — 같은 개념을 계속 시도하는데
  // 숙련에 도달하지 못하는 학생. 칩에는 학생 수가 들어가고(주목 필요
  // 칩과 같은 단위, 그래서 hero.pulse.attentionHint '명'을 같이 쓴다),
  // 개념 수와 비율은 힌트에 따로 적는다. 한 학생이 여러 개념에서 맴돌 수
  // 있어 두 숫자가 다르기 때문. 첫 안 (한국어 원어민 검토 권장).
  'hero.pulse.wheelSpinning': '맴돌이 학습',
  'hero.pulse.wheelSpinningHint': '개념 {concepts}개 · 학습 기록이 있는 학생의 {pct}%',
  'hero.pulse.wheelSpinningAttempts': '{count}회 시도',
  'students.section.title': '학생',
  'students.section.sub': '반 명단 · 숙련도 한눈에',
  'students.headers.id': '학생',
  'students.headers.last': '최근 학습',
  'students.headers.mastery': '숙련도',
  'students.headers.flag': '상태',
  // ── Admin reset-password control (issue #967, PR-3) ────────────
  // Per-row action + modal. Admin either types a new password or has
  // the server generate one (shown once, must be relayed to the
  // student). Teacher/admin-facing tone.
  'students.resetPassword.action': '비밀번호 재설정',
  'students.resetPassword.title': '비밀번호 재설정',
  'students.resetPassword.subtitle': '{id} 학생의 비밀번호를 재설정합니다.',
  'students.resetPassword.mode.generate': '비밀번호 자동 생성',
  'students.resetPassword.mode.type': '직접 입력',
  'students.resetPassword.type.placeholder': '새 비밀번호',
  'students.resetPassword.type.hint': '비밀번호는 {n}자 이상이어야 합니다.',
  'students.resetPassword.generated.warning':
    '이 비밀번호는 다시 표시되지 않습니다. 지금 복사해서 학생에게 전달하세요.',
  'students.resetPassword.generated.label': '생성된 비밀번호',
  'students.resetPassword.copy': '복사',
  'students.resetPassword.copied': '복사됨',
  'students.resetPassword.done': '완료',
  'students.resetPassword.cancel': '취소',
  'students.resetPassword.submit': '재설정',
  'students.resetPassword.submitting': '재설정 중...',
  'students.resetPassword.error.generic':
    '비밀번호를 재설정하지 못했습니다. 다시 시도해 주세요.',
  'flag.ok': '양호',
  'flag.watch': '주의',
  'flag.behind': '뒤처짐',
  'flag.new': '신규',
  // Direction A (ADR 0073) — roster heading + attention rail.
  'students.count': '학생 {n}명',
  'students.attention.title': '주목 필요',
  'students.attention.none': '지금은 주목이 필요한 학생이 없어요.',
  'students.attention.mastery': '숙련도 {pct}%',
  'students.attention.noMastery': '아직 숙련도 기록이 없어요',
  'students.attention.noSession': '이번 주 세션 없음',
  'students.attention.lastSession': '마지막 학습 {date}',
  'students.never': '기록 없음',
  'modules.section.title': '모듈',
  'modules.section.sub': '학습 자료 · 빌드 상태',
  'status.ready': '준비됨',
  'status.extracting': '텍스트 추출 중...',
  'status.building': '빌드 중',
  'status.failed': '실패',
  'status.pending': '대기',
  'assess.section.title': '평가',
  'assess.section.sub': '학생별 강점 · 약점 한눈에',
  'assess.filter.attention': '주목 필요만',
  'assess.filter.all': '전체',
  'assess.cols.strengths': '강점',
  'assess.cols.weaknesses': '약점',
  'assess.expand': '자세히',
  'assess.collapse': '접기',
  'assess.level.full': '완전',
  'assess.level.partial': '부분',
  'assess.level.insuff': '추가 학습',

  // ── Admin (issue #31) ──────────────────────────────────────
  // Admin pages are language-agnostic URL-wise (/admin, not /en/admin),
  // so lang here follows the user's stored preference. Clerk widgets
  // on the same pages pick up the matching koKR bundle automatically.
  'admin.loading': '불러오는 중...',
  'admin.errorPrefix': '오류: ',
  'admin.retry': '다시 시도',
  'admin.title.fallback': '관리자',

  'admin.createOrg.title': '학교 만들기',
  'admin.createOrg.hint':
    '관리자로 운영할 학교(조직)를 생성하세요. 생성 후 요금제를 선택하고, 관리자 대시보드에서 교사를 초대할 수 있습니다.',

  'admin.onboarding.title': '학교 설정 완료',
  'admin.onboarding.hint':
    '학교 이름을 확인하고 이용약관, 학교 책임자 확인, 데이터 처리 계약에 동의한 뒤 요금제를 선택하여 설정을 완료하세요. 완료 후 교사를 초대할 수 있으며, 교사는 수업을 만들 수 있습니다.',
  'admin.onboarding.schoolName.label': '학교 이름',
  'admin.onboarding.schoolName.placeholder': '예: 파인밸리 고등학교',
  'admin.onboarding.schoolName.save': '저장',
  'admin.onboarding.schoolName.saving': '저장 중...',
  'admin.onboarding.plansHeader': '요금제',
  'admin.onboarding.plansLocked':
    '이용약관, 학교 책임자 확인, 데이터 처리 계약에 모두 동의한 뒤 요금제를 선택할 수 있습니다.',
  'admin.onboarding.checkoutNote':
    'Clerk를 통해 Stripe에서 결제가 안전하게 처리됩니다. 결제 완료 후 이 페이지로 돌아옵니다.',
  'admin.onboarding.activating.title': '구독 활성화 중...',
  'admin.onboarding.activating.hint':
    '결제가 확인되면 몇 초 내에 자동으로 이동합니다.',

  // ── PIPA P2 (#128) chunk 3 ─────────────────────────────────────
  // PLACEHOLDER copy until pedagogy + legal review. Final Korean
  // strings land in a small text-only follow-on PR. See ADR 0034
  // "External / pre-implementation blockers".

  // Student first-login Art. 22-2 §3 plain-language notice.
  // Target audience: Korean 5학년 student. Single screen, four
  // sections (what / who / where / rights), single "이해했어요"
  // (I understand) button. NOT a checkbox-gated consent screen —
  // PIPA Art. 22-2 §3 is a NOTICE obligation, not consent capture.
  'student.notice.title': '잠깐, 알려줄 게 있어',
  'student.notice.subtitle':
    '이해(eehae)를 사용하기 전에 짧게 설명해줄게.',
  // Section 1 — what data we collect
  'student.notice.what.heading': '뭘 모아?',
  'student.notice.what.body':
    '네가 이해(eehae)에 보낸 답, 학습 진행 상황, 이름과 아이디, 학년·반·번호를 모아. 다른 건 안 모아.',
  // Section 2 — who handles it (school-as-controller posture)
  'student.notice.who.heading': '누가 관리해?',
  'student.notice.who.body':
    '네 학교(또는 학원)가 정보를 관리해. 이해(eehae)는 학교를 도와 정보를 안전하게 다룰 뿐이야.',
  // Section 3 — where it goes (sub-processor disclosure summary)
  'student.notice.where.heading': '어디로 가?',
  'student.notice.where.body':
    '네 답은 학습을 도와주는 AI 회사로 전달돼. 자세한 건 학교 선생님이나 개인정보처리방침을 봐.',
  // Section 4 — generative-AI use + output labelling (#1327 §1b)
  'student.notice.ai.heading': 'AI가 만드는 거야?',
  'student.notice.ai.body':
    '이해(eehae)가 주는 문제와 설명, 정리노트는 생성형 AI가 만들어. AI가 만든 내용에는 "AI 생성" 표시가 붙어 있어. 가끔 틀릴 수 있으니 이상하면 선생님께 물어봐.',
  // Section 5 — rights summary
  'student.notice.rights.heading': '내가 할 수 있는 건?',
  'student.notice.rights.body':
    '언제든 네 정보를 확인하거나 수정해달라고 요청할 수 있어. 학교 선생님이나 부모님께 말해줘.',
  // Acknowledge button. Plain past-tense "I understood it" —
  // semantically NOT consent capture; just notice acknowledgment.
  'student.notice.acknowledge': '이해했어요',
  'student.notice.acknowledging': '잠시만 기다려줘...',
  'student.notice.error':
    '확인을 저장하지 못했어. 잠시 후 다시 시도해줘.',

  // ── Student first-login set-password screen (issue #967, PR-3) ──
  // Reached after a legacy bootstrap login. First-time set only — no
  // current-password field. Friendly tone (학생 대상), 5학년 읽기 수준.
  'student.setPassword.title': '비밀번호를 만들어줘',
  'student.setPassword.subtitle':
    '다음부터는 학교 코드, 아이디, 그리고 이 비밀번호로 로그인할 거야.',
  'student.setPassword.new.label': '새 비밀번호',
  'student.setPassword.new.placeholder': '비밀번호 입력',
  'student.setPassword.confirm.label': '비밀번호 확인',
  'student.setPassword.confirm.placeholder': '비밀번호 다시 입력',
  'student.setPassword.hint': '{n}자 이상으로 만들어줘.',
  'student.setPassword.submit': '비밀번호 저장',
  'student.setPassword.submitting': '저장 중...',
  'student.setPassword.error.tooShort': '비밀번호는 {n}자 이상이어야 해.',
  'student.setPassword.error.mismatch': '두 비밀번호가 서로 달라.',
  'student.setPassword.error.generic':
    '비밀번호를 저장하지 못했어. 잠시 후 다시 시도해줘.',

  // Teacher / admin warranty acceptance (school-as-controller).
  // Two checkboxes (Art. 22-2 §1 guardian + Art. 26 §6
  // sub-processor) + a single submit. Both checkboxes required.
  // Korean copy needs legal counsel review before final ship.
  'warranty.title': '학교 책임자 확인',
  'warranty.hint':
    '계속하기 전에 두 가지를 확인해주세요. 두 항목 모두 체크해야 진행할 수 있습니다.',
  // Article 22-2 §1 guardian-consent warranty
  'warranty.under14.label': '14세 미만 학생 동의 확인 (PIPA Art. 22-2)',
  'warranty.under14.body':
    '본 기관에서 등록 시 14세 미만 학생의 보호자로부터 개인정보 수집·이용 동의를 받았음을 확인합니다.',
  // Article 26 §6 sub-processor warranty
  'warranty.subprocessor.label':
    'AI 위탁사 동의 (PIPA Art. 26 §6)',
  'warranty.subprocessor.body':
    '본 기관은 학습 지원 AI 위탁사가 학생 데이터를 처리하는 것에 동의합니다. (자세한 위탁사 정보는 개인정보처리방침 참조)',
  'warranty.submit': '확인하고 계속하기',
  'warranty.submitting': '저장 중...',
  'warranty.error':
    '확인을 저장하지 못했습니다. 잠시 후 다시 시도해주세요.',
  'warranty.alreadyAccepted': '이미 확인 완료',
  'warranty.version': '확인서 버전: {version}',

  // Tier 3 DPA click-through (PIPA P2 #128 chunk 4). PLACEHOLDER
  // until legal counsel review.
  'dpa.title': '데이터 처리 계약 (DPA) 동의',
  'dpa.hint':
    '아래 동의 박스를 체크하기 전에 데이터 처리 계약 전문을 검토해주세요.',
  'dpa.viewTemplate': '전체 DPA 문서 보기 →',
  'dpa.tier3.label': '데이터 처리 계약 동의 (Tier 3)',
  'dpa.tier3.body':
    '본 기관은 위 데이터 처리 계약(DPA)의 전문을 읽고 이해했으며, 모든 조항에 동의합니다.',
  'dpa.submit': '동의하고 계속하기',
  'dpa.submitting': '저장 중...',
  'dpa.error': 'DPA 동의를 저장하지 못했습니다. 잠시 후 다시 시도해주세요.',
  'dpa.englishOnly':
    '데이터 처리 계약 전문은 현재 영어로만 제공됩니다. 국문본은 법률 검토 후 제공할 예정입니다.',
  'dpa.version': '계약 버전: {version}',
  'dpa.page.title': '데이터 처리 계약 (Tier 3)',
  'dpa.page.backToTerms': '이용약관으로 돌아가기',

  // Admin agreement acceptance (ADR 0080). Placeholder copy pending
  // counsel review.
  'terms.accept.title': '이용약관 동의',
  'terms.accept.hint':
    '기관을 대표하여 eehae 이용약관에 동의해 주세요. 아래는 기관에 특히 중요한 조항의 요약이며, 전체 약관은 링크에서 확인할 수 있습니다. 이 동의는 학교 책임자 확인 및 데이터 처리 계약 동의와 별도입니다.',
  'terms.accept.viewFull': '이용약관 전문 보기 (새 창) →',
  'terms.accept.privacyNote': '개인정보 처리방침은 동의를 받는 문서가 아니라 법령에 따라 공개하는 안내입니다.',
  'terms.accept.privacyLink': '개인정보 처리방침 보기',
  'terms.accept.label': '[필수] 이용약관 동의',
  'terms.accept.body':
    '이용약관(버전 {version})을 확인했으며 기관을 대표하여 동의합니다. 본인은 기관을 대표하여 동의할 권한이 있습니다.',
  'terms.accept.submit': '동의하고 계속하기',
  'terms.accept.submitting': '저장 중...',
  'terms.accept.error': '약관 동의를 저장하지 못했습니다. 잠시 후 다시 시도해주세요.',
  'terms.accept.version': '약관 버전: {version}',
  'agreement.stale': '문서가 방금 갱신되었습니다. 페이지를 새로 고친 뒤 최신 내용을 확인하고 다시 동의해 주세요.',
  'agreements.gate.title': '약관·계약 확인 필요',
  'agreements.gate.hint':
    '이용약관, 학교 책임자 확인 또는 데이터 처리 계약 중 아직 동의하지 않았거나 변경된 항목이 있습니다. 아래 항목에 동의해야 관리자 화면을 이용할 수 있습니다.',
  'agreements.gate.history': '약관 변경 이력 보기 →',

  'admin.plan.starter': '스타터',
  'admin.plan.pro': '프로',
  'admin.plan.school': '스쿨',
  'admin.plan.enterprise_pricing': '엔터프라이즈',
  'admin.plan.enterprise_contract': '엔터프라이즈',

  'admin.dashboard.stats.plan': '요금제',
  'admin.dashboard.stats.none': '—',
  'admin.dashboard.stats.unlimited': '무제한',
  // Mastery KPI tile (#198). ``noData`` shows under the em-dash when
  // the school has no profiles yet; ``basis`` shows under the percent
  // when there's data. {n} = students with profile, {total} = roster.
  'admin.dashboard.stats.mastery': '평균 숙련도',
  'admin.dashboard.stats.mastery.noData': '데이터 없음',
  'admin.dashboard.stats.mastery.basis': '학생 {n}/{total}명 기준',
  'admin.dashboard.members.title': '멤버 및 초대',
  'admin.dashboard.members.hint':
    '여기에서 교사를 초대하세요. Clerk에서 초대 이메일이 발송되며, 수락 후 가입하면 자동으로 학교에 참여하고 수업을 만들 수 있습니다.',
  'admin.dashboard.members.devNotice':
    '멤버 및 초대 관리는 실제 Clerk 조직 세션에서만 사용할 수 있어, 개발 빠른 시작 세션에서는 표시되지 않습니다.',
  // #848 — admin-facing assessment-grading incident banner. Informative
  // variant (count / window) so an operator can judge severity, vs the
  // student banner's number-free reassurance. Reliability signal only —
  // never cost / tokens (the #442 invariant). ``{count}`` / ``{minutes}``
  // / ``{threshold}`` are interpolated via t(key, vars).
  'admin.incident.title': '채점 평가 오류가 증가하고 있습니다',
  'admin.incident.body':
    '최근 {minutes}분간 학생 세션 {count}개에서 채점에 실패했습니다 (임계값 {threshold}개). 외부 모델 제공업체 장애일 수도 있고, 채점 응답을 읽지 못한 경우일 수도 있습니다.',
  // #1470 — SEVERITY, under the breadth sentence. The count alone can't
  // separate "6 affected sessions out of 6" from "6 out of 600"; the
  // ratio can. Turn tallies, not call counts or spend (#442 holds).
  'admin.incident.severity':
    '해당 구간의 채점 대상 답변 {turns}개 중 {abstained}개가 채점되지 못했습니다 ({percent}%). {graded}개는 정상적으로 채점됐습니다.',
  // The total-outage variant: nothing graded at all, but too few
  // sessions to cross the breadth threshold. Says why the students
  // aren't seeing their banner yet.
  'admin.incident.severityTotal':
    '해당 구간에서는 한 건도 채점되지 않았습니다 — 답변 {abstained}개 전부가 채점에 실패했습니다. 영향받은 세션 수가 임계값({threshold}개)에 못 미쳐 학생에게는 아직 안내 배너가 표시되지 않았습니다.',
  // No ratio to state: ``abstained_count`` is 0 on a raised banner —
  // either the turn log is empty entirely, or it holds only graded turns.
  // The two numbers come from different tables under different rules, so
  // both shapes are reachable (see useAdminIncidentStatus) — and "0개 중
  // 0개 (0%)" / "50개 중 0개 (0%)" would read as "nothing is wrong" on a
  // banner that is only up because something is. The wording is
  // deliberately about the missing ABSTENTION, not a missing denominator,
  // so it stays true in both shapes.
  //
  // It names BOTH subsystems, telemetry first, for the same reason
  // ``admin.incident.body`` names both causes (#1470): a single-cause
  // imperative sends on-call at the wrong one. Of the three ways the two
  // tallies disagree, only two (soft-delete asymmetry, a rolled-back
  // turn) are ``learning_events`` problems. The third — window skew — is
  // the one correlated across students *during* a provider incident, and
  // in that shape the ``learning_events`` writes landed perfectly; the
  // stalled ``llm-telemetry`` drain thread is the signal. ``docs/runbook.md``
  // says so, but the banner is the surface an alert actually lands on.
  'admin.incident.severityUnknown':
    '해당 구간에 채점 실패로 기록된 답변이 없어 미채점 비율을 표시할 수 없습니다 — 영향받은 세션 수와 턴 단위 로그(learning_events)가 서로 어긋나 있습니다. 텔레메트리 워커가 밀려 있지 않은지(큐가 밀리면 마커 타임스탬프가 어긋납니다), 그리고 learning_events 기록이 정상적으로 저장되고 있는지 확인하세요.',

  // ── Admin dashboard shell (sidebar / topbar / hero / class list / pending rail) ──
  'admin.nav.classes': '반',
  'admin.nav.members': '멤버',
  'admin.topbar.searchPlaceholder': '학생, 반, 청구서 검색…',
  'admin.topbar.invite': '교사 초대',
  'admin.hero.eyebrow': '학교 운영 한눈에',
  'admin.hero.welcome': '오늘의 운영 현황입니다.',
  'admin.hero.seats.teachers': '교사 좌석',
  'admin.hero.seats.students': '학생 좌석',
  'admin.classes.eyebrow': '반 목록',
  'admin.classes.title': '학교의 모든 반',
  'admin.classes.empty': '아직 등록된 반이 없습니다.',
  'admin.classes.col.class': '반',
  'admin.classes.col.teacher': '담당 교사',
  'admin.classes.col.students': '학생',
  'admin.classes.col.mastery': '숙련도',
  'admin.pending.eyebrow': '대기 중',
  'admin.pending.title': '미수락 초대',
  'admin.pending.empty': '대기 중인 초대가 없습니다.',
  'admin.pending.sent': '{date} 발송',

  // ── ADR 0051 Phase 5: admin student management (#1091, closes #985) ──
  // Admin owns "who exists" (provision accounts); teachers/students own
  // class membership. Roster surface + CSV import + per-row reset + the
  // teacher-create toggle + the forgot-password request queue rail.
  'admin.nav.students': '학생',
  'admin.students.eyebrow': '학생 관리',
  'admin.students.title': '학생 명단',
  'admin.students.subtitle':
    '관리자가 학생 계정을 만들고, 반 배정은 교사·학생이 합니다.',
  'admin.students.loading': '학생 명단을 불러오는 중...',
  'admin.students.empty':
    '아직 등록된 학생이 없습니다. 아래에서 학생을 추가하세요.',
  'admin.students.error': '학생 명단을 불러오지 못했습니다.',
  'admin.students.count': '학생 {n}명',
  // Roster table
  'admin.students.col.id': '학생 ID',
  'admin.students.col.name': '이름',
  'admin.students.col.year': '학년·반·번호',
  'admin.students.col.created': '생성일',
  'admin.students.col.classes': '반',
  'admin.students.col.status': '상태',
  'admin.students.col.actions': '작업',
  'admin.students.noClasses': '반 미배정',
  'admin.students.badge.noPassword': '비밀번호 미설정',
  'admin.students.badge.pendingReset': '재설정 요청',
  'admin.students.badge.ok': '정상',
  // Create-one form
  'admin.students.create.label': '학생 계정 만들기',
  'admin.students.create.placeholder': '학생 ID',
  'admin.students.create.namePlaceholder': '이름 (선택)',
  'admin.students.create.button': '계정 생성',
  'admin.students.create.submitting': '생성 중...',
  'admin.students.create.hint':
    '학년이 바뀌어도 그대로 쓰는 ID를 부여하세요 (예: 입학년도-일련번호 24-005). 학년·반·번호로 만든 학번(예: 30215)은 매년 3월에 새로 부여되어 다른 학생에게 넘어가므로 ID로 쓰지 마세요. 학원은 원생 번호를 그대로 쓰셔도 됩니다. 1, 2, 3처럼 추측하기 쉬운 ID는 피하세요.',
  'admin.students.create.success': '{id} 학생 계정을 만들었습니다.',
  'admin.students.create.error.generic':
    '학생 계정을 만들지 못했습니다. 다시 시도해 주세요.',
  // Inline name edit (#1593). Saved as a correction, so a reason is required.
  'admin.students.name.add': '이름 추가',
  'admin.students.name.edit': '이름 수정',
  'admin.students.name.placeholder': '이름',
  'admin.students.name.reasonPlaceholder': '변경 사유 (정정 기록에 남습니다)',
  'admin.students.name.save': '저장',
  'admin.students.name.saving': '저장 중...',
  'admin.students.name.cancel': '취소',
  'admin.students.name.error.generic':
    '이름을 저장하지 못했습니다. 다시 시도해 주세요.',
  // CSV roster import (closes #985)
  'admin.roster.import.title': 'CSV로 일괄 등록',
  'admin.roster.import.hint':
    'student_id(또는 아이디·학생ID) 열은 필수입니다. class_code, name(또는 성명·이름), 학년·반·번호(또는 학번) 열은 선택입니다. 학번 열은 올해의 학년·반·번호로만 읽으며 로그인 ID로 쓰지 않습니다. 새 학년에는 같은 ID로 학년·반·번호만 바꿔 다시 올리면 됩니다. class_code가 없으면 반 미배정 계정으로 생성됩니다. 이름과 학년·반·번호는 교사와 관리자 화면에만 표시됩니다. (Excel: "CSV UTF-8"로 저장)',
  'admin.roster.import.choose': 'CSV 파일 선택',
  'admin.roster.import.button': '업로드',
  'admin.roster.import.submitting': '업로드 중...',
  'admin.roster.import.tooLarge': '파일이 너무 큽니다 (최대 5MB).',
  'admin.roster.import.error.generic':
    '일괄 등록에 실패했습니다. 파일을 확인하고 다시 시도해 주세요.',
  'admin.roster.import.result.title': '등록 결과',
  'admin.roster.import.result.created': '신규 학생 {n}명 반 배정',
  'admin.roster.import.result.enrolled': '기존 학생 {n}명 반 배정',
  'admin.roster.import.result.unassigned': '신규 학생 {n}명 (반 미배정)',
  'admin.roster.import.result.skipped': '이미 존재 {n}건',
  'admin.roster.import.result.namesSet': '이름 저장 {n}건',
  'admin.roster.import.result.yearFieldsSet': '학년·반·번호 저장 {n}명',
  'admin.roster.import.result.yearFieldsUnreadable':
    '학년·반·번호를 읽지 못한 학생 {n}명 (계정은 등록됨)',
  'admin.roster.import.result.errors': '오류 {n}건',
  'admin.roster.import.result.errorRow': '{row}행 ({id}): {message}',
  // Teacher-create toggle (School.allow_teacher_student_creation)
  'admin.settings.teacherCreate.label': '교사의 학생 계정 생성 허용',
  'admin.settings.teacherCreate.hint':
    '끄면 교사는 관리자가 만든 학생만 반에 추가할 수 있습니다. 켜면 교사가 새 학생 ID를 직접 만들 수 있습니다.',
  'admin.settings.teacherCreate.saving': '저장 중...',
  'admin.settings.teacherCreate.error': '설정을 저장하지 못했습니다.',
  // Forgot-password request queue rail (Phase 3 → admin resolves)
  'admin.passwordReset.eyebrow': '대기 중',
  'admin.passwordReset.title': '비밀번호 재설정 요청',
  'admin.passwordReset.empty': '대기 중인 재설정 요청이 없습니다.',
  // Cold-load failure copy — distinct from ``empty`` so a fetch error
  // can't masquerade as "queue is clear" (CodeRabbit on #1291). Mirrors
  // ``admin.students.error`` phrasing.
  'admin.passwordReset.error': '재설정 요청을 불러오지 못했습니다.',
  'admin.passwordReset.requested': '{date} 요청',
  'admin.passwordReset.action': '재설정 및 처리',

  // ── #442: customer-facing ops dashboard (/admin/ops) ──────────────
  // CUSTOMER surface — build health / session throughput / PIPA DSR
  // activity / deploy info only. NOTHING LLM-economics-related (tokens,
  // providers, cost, call counts, LLM error rates) may appear in this
  // copy; that lives on operator-only Grafana, a fully separate surface.
  'admin.nav.ops': '운영 현황',
  'admin.ops.title': '운영 현황',
  // {hours} = window_hours from the API (24 today, but server-driven).
  'admin.ops.subtitle': '지난 {hours}시간 동안의 학교 운영 지표입니다.',
  'admin.ops.loading': '운영 현황을 불러오는 중...',
  'admin.ops.error': '운영 현황을 불러오지 못했습니다.',
  'admin.ops.retry': '다시 시도',
  'admin.ops.none': '—',
  'admin.ops.build.title': '모듈 빌드 상태',
  'admin.ops.build.inFlight': '진행 중',
  'admin.ops.build.succeeded': '성공',
  'admin.ops.build.failed': '실패',
  'admin.ops.build.recentFailures': '최근 실패한 빌드',
  'admin.ops.build.noFailures': '최근 실패한 빌드가 없습니다.',
  // {phase} = localized build-phase label (below), {attempt} = attempt ordinal.
  'admin.ops.build.failureMeta': '{phase} 단계 · {attempt}번째 시도',
  'admin.ops.build.retryAria': '{name} 빌드 단계 페이지 열기',
  // Build-phase labels. Tokens mirror BUILD_PHASES in
  // V3/backend/services/module_build/tracker.py; AdminOps.tsx falls
  // back to the raw token for any vocabulary drift.
  'admin.ops.build.phase.concepts': '개념 정리',
  'admin.ops.build.phase.questions': '문항 생성',
  'admin.ops.build.phase.examples': '예제 생성',
  'admin.ops.build.phase.misconceptions': '오개념 분석',
  'admin.ops.build.phase.notes': '학습 노트',
  'admin.ops.sessions.title': '학습 세션',
  'admin.ops.sessions.started': '시작',
  'admin.ops.sessions.completed': '완료',
  'admin.ops.sessions.avgDuration': '평균 소요 시간',
  'admin.ops.sessions.avgValue': '{minutes}분',
  // Shown when avg_duration_minutes is null (nothing completed in the
  // window) — deliberately distinct from a real 0-minute average.
  'admin.ops.sessions.noCompleted': '완료된 세션 없음',
  'admin.ops.audit.title': '개인정보 권리 처리 활동',
  'admin.ops.audit.exports': '내보내기',
  'admin.ops.audit.modifications': '수정',
  'admin.ops.audit.deletions': '삭제',
  'admin.ops.audit.hint':
    '우리 학교 교직원이 처리한 개인정보 열람·정정·삭제 요청 건수입니다 (개인정보 보호법상 정보주체 권리).',
  'admin.ops.deploy.title': '배포 정보',
  'admin.ops.deploy.release': '릴리스',
  'admin.ops.deploy.releaseUnknown': '알 수 없음',
  // Honest label: the API reports PROCESS START time, which on Fly is
  // within seconds of deploy completion but is not literally "deployed
  // at" — see DeployInfo in V3/backend/routers/admin.py.
  'admin.ops.deploy.processStarted': '서버 프로세스 시작 시각',
  'admin.ops.deploy.processStartedHint':
    '새 버전을 배포하면 서버 프로세스가 다시 시작되므로, 이 시각은 마지막 배포 시점과 거의 같습니다.',

  // ── #408 Area B: per-module build-phase ladder ─────────────────────
  // (/admin/modules/{id}/build/phases — pages/AdminBuildPhases.tsx)
  'admin.buildPhases.title': '모듈 빌드 단계',
  // {id} = module id from the URL (echoed back by the API).
  'admin.buildPhases.subtitle':
    '모듈 #{id}의 단계별 빌드 상태입니다. 단계를 다시 실행하면 다른 단계는 그대로 두고 해당 단계만 재실행됩니다.',
  'admin.buildPhases.loading': '빌드 단계를 불러오는 중...',
  'admin.buildPhases.error': '빌드 단계를 불러오지 못했습니다.',
  'admin.buildPhases.reload': '다시 시도',
  'admin.buildPhases.invalidModule': 'URL의 모듈 ID가 올바르지 않습니다.',
  // Empty ladder is a legitimate state — the module pre-dates the
  // per-phase tracking table or hasn't been built yet (see the GET
  // endpoint docstring in V3/backend/routers/admin.py).
  'admin.buildPhases.empty':
    '이 모듈에는 아직 기록된 빌드 단계 정보가 없습니다. 단계별 추적이 도입되기 전에 빌드된 모듈에는 기록이 없습니다.',
  'admin.buildPhases.ladderTitle': '단계별 현재 상태',
  // Phase names mirror BUILD_PHASES in services/module_build/tracker.py.
  'admin.buildPhases.phase.concepts': '개념',
  'admin.buildPhases.phase.questions': '문제',
  'admin.buildPhases.phase.examples': '풀이 예시',
  'admin.buildPhases.phase.misconceptions': '오개념',
  'admin.buildPhases.phase.notes': '정리노트',
  'admin.buildPhases.status.pending': '대기',
  'admin.buildPhases.status.running': '진행 중',
  'admin.buildPhases.status.succeeded': '성공',
  'admin.buildPhases.status.failed': '실패',
  // 'skipped' ≠ 'failed': the phase deliberately did NOT run because
  // an upstream dependency was missing (orm/build.py status semantics)
  // — the operator retries the upstream, not the skipping phase.
  'admin.buildPhases.status.skipped': '건너뜀',
  // {attempt} = attempt ordinal (matches admin ops failureMeta style).
  'admin.buildPhases.attempt': '{attempt}번째 시도',
  'admin.buildPhases.elapsed': '{seconds}초',
  'admin.buildPhases.none': '—',
  'admin.buildPhases.retry': '단계 다시 실행',
  'admin.buildPhases.retryAria': '{phase} 단계 다시 실행',
  'admin.buildPhases.retrying': '다시 실행 중...',
  // 200-but-failed: the retry RAN and the phase failed again — points
  // the operator at the row's error text, distinct from retryError
  // (the POST itself was rejected: 409 upstream missing, 5xx, ...).
  'admin.buildPhases.retryFailed':
    '{phase} 단계를 다시 실행했지만 실패했습니다. 해당 행의 오류 내용을 확인하세요.',
  // 200-but-skipped: the retry deliberately did NOT run (upstream
  // artifact missing / cap-saturated) — the row's note explains why.
  'admin.buildPhases.retrySkipped':
    '{phase} 단계는 실행되지 않고 건너뛰었습니다. 해당 행의 안내 내용을 확인하세요.',
  'admin.buildPhases.retryError': '단계를 다시 실행하지 못했습니다.',
  'admin.buildPhases.historyTitle': '시도 기록',
  'admin.buildPhases.history.when': '시각',
  'admin.buildPhases.history.phase': '단계',
  'admin.buildPhases.history.status': '상태',
  'admin.buildPhases.history.attempt': '시도',
  'admin.buildPhases.history.elapsed': '소요 시간',

  // ── Dev: session transcripts ───────────────────────────────
  'dev.transcripts.title': '세션 대화 기록 (개발자용)',
  'dev.transcripts.empty': '아직 세션 기록이 없습니다.',
  'dev.transcripts.loading': '불러오는 중...',
  'dev.transcripts.messagesSuffix': '메시지',

  // ── Dev: quickstart harness ───────────────────────────────
  'dev.quickstart.title': '개발자 빠른 시작',
  'dev.quickstart.subtitle':
    '테스트 학교·교사·학생을 자동으로 준비하여 Clerk 및 결제 과정을 건너뜁니다.',
  'dev.quickstart.passwordLabel': '비밀번호',
  'dev.quickstart.passwordPlaceholder': '비밀번호를 입력하세요',
  'dev.quickstart.submit': '테스트 환경 시작',
  'dev.quickstart.submitting': '준비 중...',
  'dev.quickstart.errorInvalid': '비밀번호가 올바르지 않습니다',
  'dev.quickstart.errorGeneric': '테스트 환경 준비 실패: ',
  'dev.quickstart.readyTitle': '준비 완료',
  'dev.quickstart.schoolLabel': '학교',
  'dev.quickstart.teacherLabel': '교사',
  'dev.quickstart.classCodeLabel': '수업 코드',
  'dev.quickstart.studentLabel': '학생',
  'dev.quickstart.openTeacher': '교사 대시보드 열기',
  'dev.quickstart.openStudent': '학생 화면 열기',
  'dev.quickstart.exit': '테스트 세션 종료',
  'dev.quickstart.notice':
    '참고: 이 화면은 DEV_TOOLS=1 환경에서만 작동하며 실제 사용자 인증을 대체하지 않습니다.',
  'dev.quickstart.banner': '개발자 테스트 세션 활성화됨',
  'dev.quickstart.bannerExit': '종료',
  'dev.quickstart.cohortTitle': '데모 코호트',
  'dev.quickstart.cohortSub':
    '교사 대시보드가 실제 학교처럼 보이도록 모의 학생과 세션 데이터를 채웁니다. 다시 실행하면 기존 데모 데이터를 먼저 비우고 새로 만듭니다.',
  'dev.quickstart.cohortSeed': '데모 학생 만들기',
  'dev.quickstart.cohortClear': '데모 학생 지우기',
  'dev.quickstart.cohortBusy': '처리 중…',
  'dev.quickstart.cohortSeeded': '데모 학생 {n}명을 추가했습니다.',
  'dev.quickstart.cohortCleared': '데모 학생 {n}명을 삭제했습니다.',
  'dev.quickstart.cohortError': '코호트 작업 실패: ',
  'dev.quickstart.skipToTutoring': '튜터링 바로 시작',
  'dev.quickstart.skipToAssessmentEnd': '평가 마지막 단계로 이동',
  'dev.quickstart.skipToAssessmentEndBusy': '평가 준비 중...',
  // Strings added for the redesign (claude.ai/design handoff,
  // 2026-04-30): split-layout DemoEnvPanel + new ready-state hero
  // card + skip-to callouts + collapsible cohort seeder.
  'dev.quickstart.demoEnv': '데모 환경',
  'dev.quickstart.demoTagline':
    '튜터링 앱의 작동 사본입니다. 가짜 학교·교사·학생이 자동으로 준비되며, 종료 시 모든 데이터가 사라집니다.',
  'dev.quickstart.backendStatus': '백엔드 로컬 실행 중',
  'dev.quickstart.host': '호스트',
  'dev.quickstart.demoQuote1': '왜 이렇게 풀어요?',
  'dev.quickstart.demoQuote2': '예시 하나만 보여주세요',
  'dev.quickstart.demoQuote3': '3단계에서 막혔어요',
  'dev.quickstart.demoQuote4': '미분이 뭐예요?',
  'dev.quickstart.demoQuote5': '조금 더 천천히요',
  'dev.quickstart.eyebrow': '테스트 하네스',
  'dev.quickstart.heading': '세션 시작',
  'dev.quickstart.description':
    '하네스 비밀번호를 입력하면 교사 토큰을 발급받고, 학교를 자동 생성하며, 학생 세션을 미리 준비합니다. 두 화면 모두 인증된 상태로 열립니다.',
  'dev.quickstart.sessionActive': '세션 활성',
  'dev.quickstart.seededClass': '생성된 수업',
  'dev.quickstart.classCodeNote': '학생 로그인 화면에서 보이는 코드와 동일합니다.',
  'dev.quickstart.schoolSettings': '학교 설정',
  'dev.quickstart.rename': '학교 이름 변경',
  'dev.quickstart.renameSave': '저장',
  'dev.quickstart.renameSaving': '저장 중…',
  'dev.quickstart.renameCancel': '취소',
  'dev.quickstart.renameError': '학교 이름 변경 실패: ',
  'dev.quickstart.copy': '복사',
  'dev.quickstart.copied': '복사됨',
  'dev.quickstart.asTeacher': '교사 입장',
  'dev.quickstart.asStudent': '학생 입장',
  'dev.quickstart.asAdmin': '관리자 입장',
  'dev.quickstart.openDashboard': '교사 대시보드 열기',
  'dev.quickstart.openPicker': '학생 대시보드 열기',
  'dev.quickstart.openAdminDashboard': '관리자 대시보드 열기',
  'dev.quickstart.dashboardDesc':
    '모듈 관리, 평가 결과 확인, 학생 세션 기록 열람을 진행할 수 있습니다.',
  'dev.quickstart.pickerDesc':
    '실제 학생 흐름. 준비된 모듈을 골라 바로 세션을 시작할 수 있습니다.',
  'dev.quickstart.adminDashboardDesc':
    '학교 현황, 좌석 사용량, 학급별 숙련도를 확인할 수 있습니다. 멤버 관리는 실제 Clerk 세션이 필요합니다.',
  'dev.quickstart.activeStudentLabel': '현재 활성 학생',
  'dev.quickstart.activeStudentNoneAuth':
    '활성 세션 없음 — 아래에서 비밀번호를 입력해 데모 학생을 준비하세요.',
  'dev.quickstart.openLink': '열기',
  'dev.quickstart.openShortcut': '바로가기 →',
  'dev.quickstart.skipToTutoringSub':
    '평가를 건너뛰고 튜터링 화면으로 바로 이동합니다.',
  'dev.quickstart.skipToAssessmentEndSub':
    '평가 마지막 문제로 이동하여 바로 제출할 수 있습니다.',
  'dev.quickstart.cohortOptional': '선택',
  'dev.quickstart.cohortSummary': '모의 학생 16명으로 대시보드 채우기',

  // ── Marketing page extension (below splash, public-facing) ────────
  // All copy here is school-admin / hagwon-admin / teacher-facing.
  // Formal Korean B2B register; no startup-tropes. Cofounder (native
  // KO speaker) reviews and refines these strings — treat as
  // directional until that pass lands.

  // Sticky nav (appears once you scroll past the splash)
  'mkt.nav.problem': '관점',
  'mkt.nav.audiences': '대상',
  'mkt.nav.trust': '데이터 보호',
  'mkt.nav.how': '도입 절차',
  'mkt.nav.cta': '파일럿 문의',
  // Progress indicator (vertical dot rail in the choreographed
  // landing). Existing ``mkt.nav.*`` keys cover S1/S3/S4/S5/pilot;
  // these two cover the splash and S2 which have no nav entry.
  'mkt.progress.top': '맨 위',
  'mkt.progress.demo': '교실 안에서',

  // Section 1 — value proposition / inversion
  'mkt.s1.eyebrow': '선생님이 이끄는 AI',
  'mkt.s1.headline.line1': '한 명의 선생님이',
  'mkt.s1.headline.line2': '모든 학생을',
  'mkt.s1.headline.accent': '일대일',
  'mkt.s1.headline.line3': '로 가르칠 수 있다면.',
  'mkt.s1.body':
    'eehae는 선생님 한 분이 학급 전체와 일대일로 연결될 수 있도록 설계된 AI 튜터링 플랫폼입니다. 학생마다 자신의 튜터가 생기고, 선생님은 학급 전체를 하나의 화면으로 보십니다.',
  'mkt.s1.diagram.beforeLabel': '기존 모델',
  'mkt.s1.diagram.beforeTitle.line1': '선생님 한 명이',
  'mkt.s1.diagram.beforeTitle.line2': '학생 다수를 가르침',
  'mkt.s1.diagram.afterLabel': 'eehae 모델',
  'mkt.s1.diagram.afterTitle.line1': '학생마다 맞춤 1:1 튜터링,',
  'mkt.s1.diagram.afterTitle.line2': '매 강의 직후.',
  'mkt.s1.diagram.invertLabel': 'INVERTS',
  'mkt.s1.diagram.teacher': 'T',
  'mkt.s1.diagram.teacherUnder': '선생님',
  'mkt.s1.diagram.studentsUnder': '학생',
  'mkt.s1.diagram.lecturing': '강의',
  'mkt.s1.diagram.tutoring': '1:1 튜터링',

  // Section 2 — post-lecture demonstration moment
  'mkt.s2.headline': '수업 직후, 학생이 직접 이해도를 증명합니다.',
  'mkt.s2.body.p1.lead':
    '학생은 eehae를 집에 가져가서 숙제를 하지 않습니다. ',
  'mkt.s2.body.p1.strong':
    '방금 배운 내용을, 교실 안에서, 자신의 말로 설명합니다.',
  'mkt.s2.body.p2':
    '선생님은 누가 이해했고 누가 어디에서 막혔는지, 수업이 끝나기 전에 실시간으로 확인하실 수 있습니다.',
  'mkt.s2.body.p3':
    'AI를 숙제 지름길이 아니라, 선생님의 시야를 넓히는 도구로 사용합니다.',
  'mkt.s2.studentTag': '학생',
  'mkt.s2.studentPanelTitle': '3교시 수업 직후 · 14:42',
  'mkt.s2.chat.ai1': '방금 수업에서 배운 광합성 과정을 자기 말로 설명해 볼까요?',
  'mkt.s2.chat.student1':
    '식물이 햇빛을 받아서 물이랑 이산화탄소로 포도당이랑 산소를 만드는 과정이에요.',
  'mkt.s2.chat.ai2': '좋습니다. 그럼 빛이 부족하면 어떤 일이 생길까요?',
  'mkt.s2.chat.student2': '음… 광합성이 느려져서 식물이 잘 못 자라요?',
  'mkt.s2.chat.ai3':
    '맞아요. 한 가지만 더요. 광합성에 정말 필요한 게 빛만일까요? 다른 두 가지는요?',
  'mkt.s2.chat.meta': '2분 18초 · 7회 응답',
  'mkt.s2.teacherTag': '선생님 대시보드',
  'mkt.s2.teacherPanelTitle': '3-2반 광합성 단원',
  'mkt.s2.live': '실시간',
  // Pulse mockup matching the actual /api/classes/{code}/pulse shape
  // (active_now/active_total, sessions_7d, mastery_pct, attention_count).
  // Numbers are illustrative but the labels match real product surfaces.
  'mkt.s2.pulse.active': '이번 주 학습',
  'mkt.s2.pulse.activeValue': '28 / 30',
  'mkt.s2.pulse.sessions': '이번 주 세션',
  'mkt.s2.pulse.sessionsValue': '47',
  'mkt.s2.pulse.mastery': '평균 숙련도',
  'mkt.s2.pulse.masteryValue': '73%',
  'mkt.s2.pulse.attention': '주목 필요',
  'mkt.s2.pulse.attentionValue': '4',
  'mkt.s2.pulse.attentionUnit': '명',

  // Section 3 — three audiences
  'mkt.s3.headline':
    '학교, 선생님, 학원 각자의 자리에서 다르게 작동합니다.',

  'mkt.s3.school.label': '학교 관리자',
  'mkt.s3.school.headline': '우리 학교 교육의 디지털 전환, 안전하게.',
  // Bullet 1: PIPA P2 (#128 / #441) shipped a school-as-controller
  // posture, NOT the originally-planned D2C-style in-app guardian-
  // consent capture. The institution discharges Art. 22-2 with
  // guardians at enrollment (off-platform); eehae captures the
  // institution's warranty as an agreement acceptance, surfaces an
  // Art. 22-2 §3 notice to students at first login, and provides
  // a Tier-3 DPA click-through for admins. This bullet describes
  // the shipped flow — first-pass Korean copy; final wording may
  // want pedagogy / cofounder review per the file-header note
  // above and #441's deferred-follow-up convention.
  'mkt.s3.school.bullet1':
    'PIPA Art. 22-2 §3 학생 알림과 기관 보증·DPA 절차 내장',
  'mkt.s3.school.bullet2': '개인정보 보호책임자(CPO) 지정 및 관리',
  'mkt.s3.school.bullet3': '수집 항목과 보관 기간을 투명하게 공개',
  'mkt.s3.school.bullet4': '감사 가능한 운영 기록을 위한 인프라 정비 중',
  'mkt.s3.school.fitLabel': '이런 경우에 적합합니다',
  'mkt.s3.school.fit':
    '학생 데이터 보호와 교육 효과성을 동시에 추구하시는 학교에 적합합니다.',

  'mkt.s3.teacher.label': '선생님',
  'mkt.s3.teacher.headline':
    'AI는 선생님을 대체하지 않습니다. 선생님의 눈을 늘려드립니다.',
  'mkt.s3.teacher.bullet1':
    '학생 한 명 한 명의 학습 진행 상황을 한눈에 파악',
  'mkt.s3.teacher.bullet2': '어려움을 겪는 학생 자동 감지',
  'mkt.s3.teacher.bullet3':
    '수업 자료 업로드만으로 자동으로 학습 모듈 생성',
  'mkt.s3.teacher.bullet4': '수업 시간을 차지하지 않는 보조 학습 도구',
  'mkt.s3.teacher.fitLabel': '이런 경우에 적합합니다',
  'mkt.s3.teacher.fit':
    '학생 개개인의 이해도를 더 정확히 파악하고 싶은 선생님께 적합합니다.',

  'mkt.s3.hagwon.label': '학원 관리자',
  'mkt.s3.hagwon.headline':
    '기존 수업에 가볍게 더할 수 있는 AI 학습 도구.',
  'mkt.s3.hagwon.bullet1': '별도 인프라 구축 없이 바로 도입 가능',
  // Hagwon bullet about pricing: deliberately framed as "add-on
  // pricing model" rather than referencing the tuition cap directly.
  // Hagwon admins recognize the framing immediately; explicit mention
  // would read as underhanded.
  'mkt.s3.hagwon.bullet2':
    '정규 수업과 별도로 운영되는 부가 학습 서비스로, 과금도 분리 가능',
  'mkt.s3.hagwon.bullet3':
    '학부모 상담에 활용할 수 있는 학습 진행 리포트 제공',
  'mkt.s3.hagwon.bullet4': '학원 운영 흐름과 자연스럽게 연계되는 도입 절차',
  'mkt.s3.hagwon.fitLabel': '이런 경우에 적합합니다',
  'mkt.s3.hagwon.fit':
    '차별화된 학습 결과로 경쟁력을 강화하고자 하는 학원에 적합합니다.',

  // Section 4 — trust & compliance
  'mkt.s4.headline': '처음부터 안전하게 설계되었습니다.',
  'mkt.s4.pillar1.title': '개인정보 보호',
  'mkt.s4.pillar1.subtitle': 'PIPA Compliance',
  'mkt.s4.pillar1.body':
    '학생·학부모 동의를 명시적으로 받고, 수집 항목과 보관 기간을 투명하게 공개합니다. 개인정보 보호책임자(CPO)를 지정하여 운영합니다.',
  'mkt.s4.pillar2.title': '데이터 처리 위치',
  'mkt.s4.pillar2.subtitle': 'Processing Location',
  // Pillar 2 (was "Data Sovereignty / 모든 처리 국내") rewritten:
  // Fly machines are in NRT (Tokyo region), not Korea. The honest
  // version names the actual countries data passes through and the
  // disclosure obligation around that.
  'mkt.s4.pillar2.body':
    '학생 데이터의 처리 위치(국내 또는 해외)를 명시적으로 고지하고, 국외 이전이 발생하는 경우 사전 동의를 별도로 받습니다.',
  'mkt.s4.pillar3.title': '투명한 운영',
  'mkt.s4.pillar3.subtitle': 'Operational Transparency',
  'mkt.s4.pillar3.body':
    '어떤 데이터를 수집하고, 어떻게 사용하며, 어디에 저장하는지 모두 공개합니다.',

  // Section 5 — how it works
  'mkt.s5.headline': '세 단계로, 한 학급에서 시작합니다.',
  'mkt.s5.step1.title': '선생님이 수업 자료를 올립니다.',
  'mkt.s5.step1.body':
    '교과서 PDF, 수업 노트, 또는 직접 작성한 자료를 업로드하면 eehae가 자동으로 학습 모듈을 생성합니다.',
  'mkt.s5.step2.title': '학생들이 수업 직후 이해도를 점검합니다.',
  'mkt.s5.step2.body':
    '각 학생이 AI 튜터와 일대일로 대화하며 핵심 개념을 자신의 말로 설명하고 연습합니다.',
  'mkt.s5.step3.title': '선생님이 한눈에 결과를 봅니다.',
  'mkt.s5.step3.body':
    '누가 잘 이해했는지, 누가 도움이 필요한지 대시보드로 확인하고 다음 수업을 조정합니다.',

  // Section 6 — pilot CTA
  'mkt.s6.headline':
    '우리 학교에서 어떻게 작동하는지 직접 확인해보세요.',
  'mkt.s6.body':
    '한 학급, 한 단원으로 시작하는 6-8주 파일럿을 함께 진행합니다. 사전에 정의한 성공 기준에 따라, 도입 부담 없이 결과를 먼저 확인하실 수 있습니다.',
  'mkt.s6.metaPeriodLabel': '파일럿 기간',
  'mkt.s6.metaPeriodValue': '6-8주',
  'mkt.s6.metaScopeLabel': '시작 단위',
  'mkt.s6.metaScopeValue': '1학급 · 1단원',
  // Pilot form (#181) is commented out in the JSX. These keys exist
  // ahead of time so the form can be enabled via uncomment without
  // a separate i18n PR.
  'mkt.s6.formTitle': '파일럿 문의',
  'mkt.s6.formHint': '담당자가 영업일 기준 2일 이내에 회신드립니다.',
  'mkt.s6.form.org': '기관명',
  'mkt.s6.form.orgPlaceholder': '예) 한빛중학교 / 강남수학학원',
  'mkt.s6.form.name': '담당자 성함',
  'mkt.s6.form.namePlaceholder': '김민서',
  'mkt.s6.form.role': '직책',
  'mkt.s6.form.rolePlaceholder': '교무부장 / 원장',
  'mkt.s6.form.email': '이메일',
  'mkt.s6.form.emailPlaceholder': 'name@school.kr',
  'mkt.s6.form.phone': '전화번호',
  'mkt.s6.form.phoneOptional': '(선택)',
  'mkt.s6.form.phonePlaceholder': '010-0000-0000',
  'mkt.s6.form.msg': '간단한 메시지',
  'mkt.s6.form.msgPlaceholder':
    '대상 학년, 과목, 시작 희망 시기 등을 적어주시면 도움이 됩니다.',
  'mkt.s6.form.submit': '파일럿 문의하기',
  'mkt.s6.form.submitting': '전송 중…',
  'mkt.s6.form.errorGeneric':
    '전송에 실패했습니다. 잠시 후 다시 시도하시거나 contact@eehae.app로 직접 메일 주세요.',
  'mkt.s6.form.successTitle': '문의가 접수되었습니다.',
  'mkt.s6.form.successBody':
    '담당자가 영업일 기준 1~2일 이내에 회신드립니다. 접수 확인 메일이 입력하신 주소로 발송됩니다.',
  // PIPA Art. 15 §2 inline consent disclosure (issue #181). Concise
  // — the full §2 collection items + retention windows live in the
  // privacy policy, which the link points at.
  'mkt.s6.form.consent':
    '제출 시 입력하신 정보가 파일럿 문의 응답 목적으로 수집·이용되며, 응답 완료 후 1년간 보관됨에 동의하시는 것으로 간주됩니다. 자세한 내용은',
  'mkt.s6.form.consentLink': '개인정보처리방침을 참고하세요.',
  // Pre-#181 placeholder CTA (now removed; form is live). Keys
  // retained in case the form has to be temporarily disabled again.
  'mkt.s6.contactCta': '문의하기',
  'mkt.s6.contactNote':
    '현재는 이메일로 문의를 받습니다. 정식 신청 양식은 곧 제공될 예정입니다.',

  // Section 7 — footer
  'mkt.s7.tagline': '교육은 더 나아져야 합니다',
  'mkt.s7.info.cpoLabel': '개인정보 보호책임자',
  // TODO: previous CPO left the project. Fill in the new designee's
  // name (PIPA Art. 31) and re-enable the gated footer row in
  // MarketingExtension.tsx (OPERATOR-INFO-PENDING).
  'mkt.s7.info.cpoValue': '미정',
  // INCORPORATION-PENDING (#182): company + biz fields below stay
  // gated in the JSX until 사업자등록 completes; kept in i18n so the
  // flip is a one-line change. Contact email is live (#184). The
  // address (formerly live per #183) is gated again — see the
  // addressValue TODO below.
  'mkt.s7.info.companyLabel': '상호',
  'mkt.s7.info.companyValue': '(주) 이해',
  'mkt.s7.info.bizLabel': '사업자',
  'mkt.s7.info.bizValueTbd': '등록 진행 중',
  'mkt.s7.info.addressLabel': '주소',
  // TODO: registered office address removed after the previous
  // operator's departure. Fill in the new registered address and
  // re-enable the gated footer row in MarketingExtension.tsx
  // (OPERATOR-INFO-PENDING).
  'mkt.s7.info.addressValue': '미정',
  'mkt.s7.info.contactLabel': '대표문의',
  'mkt.s7.info.contactValue': 'contact@eehae.app',
  'mkt.s7.col.product': '제품',
  'mkt.s7.col.legal': '법적 고지',
  'mkt.s7.col.contact': '문의',
  'mkt.s7.link.problem': '관점',
  'mkt.s7.link.audiences': '기관별 가치',
  'mkt.s7.link.trust': '데이터 보호',
  'mkt.s7.link.how': '도입 절차',
  'mkt.s7.link.terms': '이용약관',
  'mkt.s7.link.privacy': '개인정보처리방침',
  'mkt.s7.link.cpo': '개인정보 보호책임자',
  'mkt.s7.link.cookies': '쿠키 정책',
  'mkt.s7.link.pilot': '파일럿 신청',
  'mkt.s7.link.press': '언론·제휴',
  'mkt.s7.copyright': '© 2026 eehae. All rights reserved.',

  // ── Account settings (PIPA P3, issue #129 PR 5) ──────────────
  //
  // Student-facing copy targets ~5학년 reading level: explicit verbs,
  // no English-loan jargon ("백업 회전" / "backup rotation" replaced
  // with "30일 동안 보관됐다가 영구 삭제됩니다"). Educator copy uses
  // adult vocabulary — formal "내보내기" / "삭제".
  //
  // The 30-day window is hardcoded as text in the modal body (NOT
  // interpolated from a backend response) because the modal fires
  // BEFORE the DELETE call. The post-delete receipt screen interpolates
  // the actual returned ``hard_delete_scheduled_after_days`` so any
  // operator override of ``RETENTION_SOFT_DELETE_GRACE_DAYS`` lands
  // accurately on the screen the user actually keeps.
  'modal.cancel': '취소',
  'account.settings.title': '계정 설정',
  'account.nav.back': '뒤로',
  'account.educator.org': '소속: {name}',

  // Export section.
  'account.export.title': '내 데이터 다운로드',
  'account.export.loading': '준비 중...',
  'account.export.button.student': '내 정보 받기',
  'account.export.button.educator': '내 데이터 내보내기',
  'account.export.student.desc':
    '내가 만든 학습 기록을 zip 파일로 받을 수 있어. 이런 자료가 들어 있어:',
  'account.export.includes.student.sessions':
    '내가 했던 수업 기록 (문제, 답, 선생님 피드백)',
  'account.export.includes.student.assessments':
    '내 학습 진척도 (어떤 개념을 익혔는지 정리한 표)',
  'account.export.includes.student.consents':
    '내가 동의한 약관 기록',
  'account.export.includes.student.accessLog':
    '내 정보를 본 사람의 기록 (선생님, 관리자)',
  'account.export.teacher.desc':
    '본인의 계정 데이터를 zip으로 내려받습니다. 학교 소유의 학생·반 데이터는 별도 — 다음이 포함됩니다:',
  'account.export.admin.desc':
    '관리자 계정 데이터를 zip으로 내려받습니다. 학교 빌링 정보도 포함됩니다 — 다음이 포함됩니다:',
  'account.export.includes.teacher.account':
    '교사 계정 정보 + 담당 반·단원 목록',
  'account.export.includes.admin.account':
    '관리자 계정 정보 + 학교 정보',
  'account.export.includes.educator.consents': '동의 기록',
  'account.export.includes.educator.accessLog':
    '본인이 학생 데이터를 열람한 감사 로그',
  'account.export.includes.admin.billing':
    '학교 구독·결제 정보 (관리자 전용)',

  // Delete section.
  'account.delete.title': '계정 삭제',
  'account.delete.button.student': '계정 지우기',
  'account.delete.button.educator': '계정 삭제',
  'account.delete.student.desc':
    '계정을 지우면 내 학습 기록도 모두 지워져. 30일 동안은 안전을 위해 보관됐다가 영구히 사라져.',
  'account.delete.teacher.desc':
    '교사 본인 계정만 삭제됩니다. 학교가 소유한 반·학생·세션 데이터는 그대로 유지되어 학교가 계속 관리할 수 있습니다.',
  'account.delete.admin.desc':
    '관리자 본인 계정만 삭제됩니다. 학교 데이터·다른 교사 계정은 유지됩니다. 본인이 학교의 마지막 관리자인 경우 먼저 Clerk 조직 설정에서 다른 교사를 관리자로 승격해야 합니다 (그렇지 않으면 삭제가 409로 거절됩니다).',

  // Confirmation modal (per-role title + body).
  'account.delete.confirm.title.student': '정말 계정을 지울까?',
  'account.delete.confirm.title.teacher': '교사 계정을 삭제하시겠습니까?',
  'account.delete.confirm.title.admin': '관리자 계정을 삭제하시겠습니까?',
  'account.delete.confirm.button.student': '응, 지우기',
  'account.delete.confirm.button.educator': '삭제하기',
  'account.delete.confirm.loading': '처리 중...',
  'account.delete.confirm.body.student.intro':
    '이 버튼을 누르면 바로 일어나는 일:',
  'account.delete.confirm.body.student.tokens':
    '바로 로그아웃돼. 다음에는 다시 로그인해야 해.',
  'account.delete.confirm.body.student.cascade':
    '내 학습 기록은 {days}일 동안 보관됐다가 영구히 지워져. ({days}일 안에 마음이 바뀌면 선생님께 알려줘.)',
  'account.delete.confirm.body.teacher.intro':
    '진행하면 다음과 같이 처리됩니다:',
  'account.delete.confirm.body.admin.intro':
    '진행하면 다음과 같이 처리됩니다:',
  // The ``educator`` prefix means this string renders for BOTH the
  // teacher AND admin variants of the confirmation modal — the
  // earlier "교사 본인 행만" phrasing rendered incorrectly when the
  // caller was an admin. "본인 계정 행만" is role-neutral.
  // CodeRabbit on PR #351.
  'account.delete.confirm.body.educator.cascade.row':
    '본인 계정 행만 소프트 삭제됩니다 (deleted_at 스탬프).',
  'account.delete.confirm.body.educator.cascade.classes':
    '담당하던 반·학생·세션은 그대로 유지됩니다. 학교의 다른 관리자가 재배정할 수 있습니다.',
  'account.delete.confirm.body.educator.cascade.window':
    '{days}일 후 영구 삭제됩니다. 그 사이에는 백업 로테이션의 일부로 남습니다.',
  'account.delete.confirm.body.admin.lastAdmin':
    '본인이 마지막 관리자라면 요청은 409로 거절됩니다. 먼저 Clerk에서 다른 관리자를 지정하세요.',

  // Post-delete receipt screen.
  'account.delete.done.title': '계정 삭제 처리됨',
  'account.delete.done.body':
    '계정이 소프트 삭제되었습니다. {days}일 후 영구히 제거됩니다.',
  'account.delete.done.signedOut':
    '이미 로그아웃되었습니다. 다음 페이지로 이동해도 다시 로그인이 필요합니다.',
  'account.delete.done.returnHome': '처음 화면으로',
  'account.delete.done.educator.teacher.followup':
    '본인이 담당하던 반은 학교 관리자가 다른 교사에게 재배정할 수 있습니다.',
  'account.delete.done.educator.admin.followup':
    '본인이 관리하던 학교 데이터는 다른 관리자가 계속 관리합니다.',
  'account.delete.done.educator.returnDashboard': '대시보드로 돌아가기',

  // Settings link surfaced from each role-home page.
  'account.link.fromStudentLogin': '설정',
  'account.link.fromTeacherDashboard': '계정 설정',
  'account.link.fromAdminHome': '계정 설정',

  // ── Revocation banner (#306 surface 5) ─────────────────────
  // Shown when the backend returns 401/403 and the existing
  // auto-recovery flows (which hard-redirect on stale dev /
  // student tokens) don't claim the failure. Most common case:
  // a Clerk-authed teacher whose org membership was revoked by
  // an admin — their Clerk session still appears valid client-
  // side, but every protected call gets rejected by the
  // backend's org-scoped permission checks.
  'revocation.banner.title': '접근 권한이 변경되었습니다',
  'revocation.banner.body':
    '관리자가 회원님의 접근 권한을 변경했을 수 있습니다. 페이지를 새로 고침해서 최신 상태를 확인해 주세요.',
  'revocation.banner.reload': '새로 고침',
  'revocation.banner.dismiss': '닫기',

  // ── ClassMaterialsPage (#451 PR-4) ─────────────────────────
  // 교과서/자료 업로드 + 챕터 선택 화면. 교사가 한 권의
  // 교과서를 미리 올려두고 일 단위로 "오늘은 5장" 식으로
  // 학생들에게 노출한다.
  'materials.title': '{code} 수업 자료',
  'materials.subtitle':
    '교과서 또는 챕터 자료 PDF를 업로드하면 자동으로 챕터 단위로 나뉘어 일별 수업으로 사용할 수 있습니다.',
  'materials.backToDashboard': '대시보드로 돌아가기',
  'materials.backToClasses': '← 수업 목록으로',
  'materials.missingClassCode': '잘못된 주소입니다 — 수업 코드를 찾을 수 없습니다.',
  'materials.loading': '자료를 불러오는 중...',
  'materials.listTitle': '등록된 자료',
  'materials.col.pages': '쪽수',
  'materials.col.uploaded': '업로드',
  'materials.empty.title': '아직 등록된 자료가 없습니다',
  'materials.empty.body':
    '첫 번째 자료를 업로드해 보세요. 교과서 한 권 또는 단원 PDF를 한 번에 올리면 됩니다.',
  'materials.error.title': '자료를 불러올 수 없습니다',
  'materials.error.body':
    '일시적인 네트워크 문제일 수 있습니다. 잠시 후 다시 시도해 주세요.',

  // ── MaterialUpload ─────────────────────────────────────────
  'materials.upload.title': '새 자료 업로드',
  'materials.upload.replaceTitle': '자료 교체 업로드',
  'materials.upload.hint':
    '최대 100MB까지 업로드할 수 있습니다. 교과서 한 권 단위 업로드를 권장합니다.',
  'materials.upload.filenameLabel': '자료 이름',
  'materials.upload.filenamePlaceholder': '예: 중학 과학 1학년',
  'materials.upload.fileLabel': 'PDF 파일',
  'materials.upload.chooseFile': '파일 선택',
  'materials.upload.noFile': '선택된 파일 없음',
  'materials.upload.filenameRequired': '자료 이름을 입력하세요.',
  'materials.upload.fileRequired': 'PDF 파일을 선택하세요.',
  'materials.upload.tooLarge': '파일이 너무 큽니다 (최대 100MB).',
  'materials.upload.submit': '업로드',
  'materials.upload.submitReplace': '교체 업로드',
  'materials.upload.uploading': '업로드 중...',
  'materials.upload.uploadFailed': '업로드 실패',
  'materials.upload.cancel': '취소',

  // ── MaterialCard ───────────────────────────────────────────
  'materials.card.pages': '{count}쪽',
  'materials.card.uploaded': '업로드: {date}',
  'materials.card.chunked': '챕터 분석 완료',
  'materials.card.chunkPending': '챕터 분석 중',
  'materials.card.teachChapter': '챕터로 수업하기',
  'materials.card.replace': '교체',

  // ── ChapterPicker ──────────────────────────────────────────
  'chapter.picker.title': '챕터 선택',
  'chapter.picker.close': '닫기',
  'chapter.picker.loading': '챕터 정보를 불러오는 중...',
  'chapter.picker.loadFailed': '챕터 정보를 불러올 수 없습니다.',
  'chapter.picker.pageRange': '{start}–{end}쪽',
  'chapter.picker.pageRangeStartOnly': '{start}쪽부터',
  'chapter.picker.pageRangeEndOnly': '{end}쪽까지',
  'chapter.picker.teach': '이 챕터로 수업하기',
  'chapter.picker.teaching': '생성 중...',
  'chapter.picker.buildFailed': '수업 생성에 실패했습니다.',
  'chapter.picker.detectionPending':
    '챕터 자동 분석이 아직 진행 중입니다. 잠시 후 다시 열거나, 아래 수동 입력을 사용하세요.',
  'chapter.picker.detectionEmpty':
    '자동으로 챕터를 찾지 못했습니다. 아래에서 페이지 범위를 직접 입력하세요.',
  'chapter.picker.manualTitle': '직접 페이지 범위 지정',
  'chapter.picker.manualHint':
    '교사가 직접 챕터 이름과 페이지 범위를 정해서 수업을 만들 수 있습니다.',
  'chapter.picker.manualNameLabel': '수업 이름',
  'chapter.picker.manualNameRequired': '수업 이름을 입력하세요.',
  'chapter.picker.manualPagesInvalid':
    '시작 페이지와 끝 페이지를 올바르게 입력하세요 (시작 ≤ 끝).',
  'chapter.picker.manualStart': '시작쪽',
  'chapter.picker.manualEnd': '끝쪽',

  // ── TeacherDashboard (#451 PR-4 additions, #515 skeleton) ─
  'teacher.dashboard.manageMaterials': '수업 자료 관리',
  'teacher.dashboard.loading': '대시보드 로딩 중...',

  // ── TodaysFocusPill ────────────────────────────────────────
  'focus.current': '오늘의 수업: {name}',
  'focus.none': '오늘의 수업 없음',
  'focus.setCta': '설정',
  'focus.clear': '해제',
  'focus.clearing': '해제 중...',
  'focus.loadFailed': '상태를 불러올 수 없습니다',
  'focus.staleFallback': '오늘의 수업 정보가 오래되었습니다',

  // ── Help / documentation surface (#620, PR 1 — scaffold) ───
  // Chrome strings only. Per-article body content lives outside
  // i18n in src/data/help/articles/{lang}/{role}/{categoryId}/{slug}.md (PR 2 ships the loader);
  // per-category + per-article titles live in src/data/help/index.ts
  // as ``{ ko, en }`` LocalizedString values, parity-enforced by the
  // TypeScript type rather than this dictionary.
  'help.brand.suffix': '도움말',
  'help.sidebar.aria': '도움말 카테고리',
  'help.sidebar.tag.teacher': '교사용',
  'help.sidebar.tag.student': '학생용',
  'help.sidebar.tag.admin': '관리자용',
  'help.sidebar.all_topics': '전체 보기',
  'help.sidebar.search.placeholder': '문서 검색',
  'help.sidebar.search.aria': '도움말 검색',
  'help.topbar.search.placeholder': '도움말 검색…',
  'help.topbar.search.aria': '도움말 검색',
  'help.topbar.breadcrumb.aria': '현재 위치',
  // Hero copy — role-framed intro on each landing.
  'help.hero.teacher.eyebrow': '교사 가이드',
  'help.hero.teacher.title': '수업과 학생을 더 잘 이끌기',
  'help.hero.teacher.lede':
    '학교 설정부터 단원 빌드, 학생별 학습 지표 해석까지 — 자주 묻는 흐름을 모았습니다.',
  'help.hero.student.eyebrow': '학생 가이드',
  'help.hero.student.title': '오늘 수업이 어렵지 않게',
  'help.hero.student.lede':
    '로그인 방법, 튜터와의 대화, 정리노트 보기 — 학습 흐름을 이어가는 데 필요한 안내입니다.',
  'help.hero.admin.eyebrow': '관리자 가이드',
  'help.hero.admin.title': '학교 운영과 컴플라이언스',
  'help.hero.admin.lede':
    '좌석·결제·PIPA 준수와 감사 로그 — 학교 운영자가 자주 확인하는 자료를 모았습니다.',
  'help.hero.search.placeholder': '무엇을 도와드릴까요?',
  'help.hero.search.aria': '도움말 검색',
  'help.hero.meta.articleCount': '문서 {count}개',
  'help.hero.meta.docsVersion': '버전 {version}',
  // Landing sections.
  'help.landing.popular.title': '많이 찾는 문서',
  'help.landing.categories.title': '카테고리별 둘러보기',
  // Cards.
  'help.card.readingTime': '{min}분 읽기',
  // ComingSoon placeholder — shown until PR 2 publishes article bodies.
  'help.coming_soon.title': '준비 중입니다',
  'help.coming_soon.body': '이 문서는 곧 공개됩니다.',
  'help.coming_soon.note':
    '문서 본문 작업이 진행 중입니다. 도움이 시급하시면 학교 관리자 또는 담당 교사에게 문의해 주세요.',
  'help.coming_soon.back': '도움말 첫 화면으로',
  // Sidebar entry-point labels in the main app shells.
  'help.entry.label': '도움말',
  'help.entry.aria': '도움말 페이지로 이동',
  // Search results (PR 3 additions).
  'help.search.results.title': '검색 결과',
  'help.search.noMatches.title': '일치하는 문서가 없습니다',
  'help.search.noMatches.meta': '"{q}"',
  'help.search.noMatches.hint':
    '다른 키워드로 다시 검색해 보시거나, 아래 카테고리에서 둘러보세요.',
  // Article page (PR 2 additions).
  'help.toc.label': '목차',
  // Help → back to the regular app view (sidebar exit link).
  'help.back.teacher': '대시보드로 돌아가기',
  'help.back.student': '학습으로 돌아가기',
  'help.back.admin': '관리자 홈으로 돌아가기',
  'help.article.updatedAt': '마지막 업데이트: {date}',
  'help.article.version': '문서 버전 {v}',
  'help.article.reviewedBy': '검수: {who}',
  'help.article.related': '관련 문서',
  // Admin contact form + escalation (PR 4 additions).
  'help.contact.sidebar.label': 'eehae 운영팀에 문의',
  'help.contact.crumb': 'eehae 운영팀에 문의',
  'help.contact.title': 'eehae 운영팀에 문의',
  'help.contact.subtitle':
    '학교 운영, 결제, 컴플라이언스, 기술 통합 관련 문의를 보내주세요. 메시지 본문과 함께 전송 시각, 사용자 ID, 학교 ID, 정책 버전이 자동으로 감사 로그에 기록됩니다.',
  'help.contact.fields.category': '문의 유형',
  'help.contact.fields.subject': '제목',
  'help.contact.fields.subject.placeholder': '예: 5월 청구서가 두 번 발행되었습니다',
  'help.contact.fields.message': '내용',
  'help.contact.fields.message.hint':
    '상황과 영향받은 화면(또는 학생·반)을 함께 적어주시면 응답이 빨라집니다. 학생 식별 정보는 직접 포함하지 마시고 익명화된 ID를 사용해 주세요.',
  'help.contact.fields.message.placeholder':
    '예: 5월 분 청구서가 2건 발행되었습니다. 청구서 ID INV-2026-05-0421 / 0422. 모두 결제 완료 상태이며, 환불 가능 여부를 확인하고 싶습니다.',
  'help.contact.category.billing.label': '결제 · 청구',
  'help.contact.category.billing.hint': '청구서, 결제 수단, 환불, 부가세',
  'help.contact.category.compliance.label': '컴플라이언스',
  'help.contact.category.compliance.hint': 'PIPA, DPA, 데이터 권한 응답',
  'help.contact.category.technical.label': '기술',
  'help.contact.category.technical.hint': 'Clerk, 웹훅, SSO, 통합',
  'help.contact.category.other.label': '기타',
  'help.contact.category.other.hint': '위 항목에 해당하지 않는 모든 문의',
  'help.contact.audit.label': '감사 로그 기록',
  'help.contact.audit.body':
    '본 문의는 메시지 본문과 함께 전송 시각, 사용자 ID, 학교 ID, 정책 버전, 카테고리가 감사 로그에 기록됩니다. 학생 데이터는 직접 포함하지 마시고 익명화된 ID를 사용해 주세요.',
  'help.contact.actions.send': '문의 전송',
  'help.contact.actions.sending': '전송 중...',
  'help.contact.actions.reset': '초기화',
  'help.contact.charCount': '{n} / {max}',
  'help.contact.error.label': '전송 실패',
  'help.contact.success.title': '문의가 접수되었습니다',
  'help.contact.success.body':
    '담당자가 영업일 1일 내에 회신드립니다. 접수 번호 #{id} — 후속 문의 시 참조해 주세요.',
  'help.contact.success.another': '다른 문의 작성',
  'help.contact.aside.flow.title': '문의 처리 흐름',
  'help.contact.aside.flow.step1': '카테고리에 맞는 운영 큐로 라우팅됩니다.',
  'help.contact.aside.flow.step2': '메시지 + 메타데이터가 감사 로그에 기록됩니다.',
  'help.contact.aside.flow.step3': '담당자가 영업일 1일 내 회신합니다.',
  'help.contact.aside.sla.window': '응답 시한',
  'help.contact.aside.sla.window.value': '영업일 1일',
  'help.contact.aside.sla.compliance': '컴플라이언스 사안',
  'help.contact.aside.sla.compliance.value': '4시간 이내 회신',
  'help.contact.aside.sla.hours': '운영 시간',
  'help.contact.aside.sla.hours.value': '09:00 – 19:00 KST',
  'help.contact.aside.sla.email': '연락 이메일',
  'help.contact.aside.sla.email.value': 'contact@eehae.app',
  // Escalation panel for teacher + student landings.
  'help.escalation.title': '원하시는 문서를 찾지 못하셨나요?',
  'help.escalation.teacher.body':
    '대시보드에서 해결되지 않는 운영·정책 문의는 학교 관리자에게 직접 전달해 주세요. 학교 관리자는 eehae 운영팀에 직접 문의할 수 있는 페이지를 가지고 있습니다.',
  'help.escalation.student.body':
    '도움말로 해결이 안 되면 담당 선생님께 짧게 말해 보세요. 선생님이 수업 흐름을 가장 잘 아시고, 다음 수업 전에 답을 받을 수 있어요.',
} as const

export default ko
export type TranslationKey = keyof typeof ko
